/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/api/v1/haystack/components': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Available Components
     * @description Returns components available to be used in deepset AI Platform.
     *
     *     By default, it returns the components for the deepset domain.
     */
    get: operations['get_available_components_api_v1_haystack_components_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/haystack/components/input-output': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Components Input Output
     * @description Returns the haystack components available for the domain of the current version.
     *
     *     This can be used to identify the input values required for each component and the output
     *     values that will be returned.
     *
     *     By default, it returns the components for the deepset domain.
     *
     *     If names are provided, it will return the input/output schema for the provided components.
     *     We use exact match for the component names.
     *     If no names are provided, it will return the input/output schema for all available components.
     */
    get: operations['get_components_input_output_api_v1_haystack_components_input_output_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/haystack/components/input-output/generate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Components Dynamic Input Output
     * @description Returns updated input output schemas for Haystack components containing dynamic parameters.
     *
     *     Dynamic parameters are component input output parameters, which are postulated by component init params.
     */
    post: operations['create_components_dynamic_input_output_api_v1_haystack_components_input_output_generate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/infrastructure/document_stores': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List OpenSearch credentials
     * @description List all OpenSearch credentials that exist for the current organization.
     */
    get: operations['list_available_opensearch_credentials_api_v1_infrastructure_document_stores_get'];
    put?: never;
    /**
     * Add OpenSearch credentials
     * @description Add credentials to your own OpenSearch cluster.
     */
    post: operations['add_opensearch_credentials_api_v1_infrastructure_document_stores_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/infrastructure/document_stores/{credentials_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete OpenSearch credentials
     * @description Delete credentials to your own OpenSearch cluster.
     */
    delete: operations['delete_opensearch_credentials_api_v1_infrastructure_document_stores__credentials_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/infrastructure/file_stores': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Available S3 Credentials
     * @description List all S3 bucket credentials that exist for the current organization.
     */
    get: operations['list_available_s3_credentials_api_v1_infrastructure_file_stores_get'];
    put?: never;
    /**
     * Add S3 Credentials
     * @description Add credentials to your own S3 bucket.
     */
    post: operations['add_s3_credentials_api_v1_infrastructure_file_stores_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/infrastructure/file_stores/{credentials_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete S3 Credentials
     * @description Delete credentials to your own S3 bucket.
     */
    delete: operations['delete_s3_credentials_api_v1_infrastructure_file_stores__credentials_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/me': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Read Users Me
     * @description Retrieve the properties of the current user.
     */
    get: operations['read_users_me_api_v1_me_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/me/workspaces/{workspace_name}/permissions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Read Users Me Workspace Permissions
     *
     *     [beta]
     * @description Returns the permissions for the current user on the specified workspace.
     *
     *     It is a list of Permission objects, where each Permission has:
     *         - "asset" is the type of the asset the user has permissions to.
     *         - "action" is the action the user can perform on the asset.
     *
     *     Example:
     *     ```
     *      for an admin: [{"asset": "pipelines", "action": "write"}]
     *      for a search_user: [{"asset": "pipelines", "action": "read"}, ...]
     *     ``` We're still working on this endpoint, which means it may change. Once it's stable, we'll remove the 'beta' label.
     */
    get: operations['read_users_me_workspace_permissions_api_v1_me_workspaces__workspace_name__permissions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/model': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Model
     * @description Returns a list of models available for the specified node type.
     */
    get: operations['get_model_api_v1_model_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/model_registry_token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Token Deprecated
     * @description Returns the Hugging Face model token.
     */
    get: operations['get_token_deprecated_api_v1_model_registry_token_get'];
    /**
     * Update Token Deprecated
     * @description Replaces the current Hugging Face model token with a new one.
     */
    put: operations['update_token_deprecated_api_v1_model_registry_token_put'];
    /**
     * Save Token Deprecated
     * @description Imports your Hugging Face model token and saves it in deepset AI Platform.
     */
    post: operations['save_token_deprecated_api_v1_model_registry_token_post'];
    /**
     * Remove Token Deprecated
     * @description Deletes the Hugging Face model token from deepset AI Platform.
     */
    delete: operations['remove_token_deprecated_api_v1_model_registry_token_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/model_registry_tokens': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Tokens
     * @description Returns the existing model tokens.
     */
    get: operations['get_tokens_api_v1_model_registry_tokens_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/model_registry_tokens/{provider}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Token
     * @description Returns the model token from a specific model provider.
     */
    get: operations['get_token_api_v1_model_registry_tokens__provider__get'];
    /**
     * Update Token
     * @description Replaces the current model token with a new one.
     */
    put: operations['update_token_api_v1_model_registry_tokens__provider__put'];
    /**
     * Save Token
     * @description Imports your model token and saves it in deepset AI Platform.
     */
    post: operations['save_token_api_v1_model_registry_tokens__provider__post'];
    /**
     * Remove Token
     * @description Deletes the model token from deepset AI Platform.
     *
     *     If you delete the model token, the pipelines using it stop working.
     */
    delete: operations['remove_token_api_v1_model_registry_tokens__provider__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/organization': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Organization
     * @description Returns the name of the current deepset organization.
     */
    get: operations['get_organization_api_v1_organization_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/organization/permissions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Permissions
     *
     *     [beta]
     * @description Returns the permissions that exist in the organization. We're still working on this endpoint, which means it may change. Once it's stable, we'll remove the 'beta' label.
     */
    get: operations['get_permissions_api_v1_organization_permissions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/organization/{organization_id}/invitation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Invite User To Organization
     * @description Sends an email to the user inviting them to your deepset organization.
     */
    post: operations['invite_user_to_organization_api_v1_organization__organization_id__invitation_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/organization/{organization_id}/roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Roles
     *
     *     [beta]
     * @description Returns the roles that exist in the specified organization. We're still working on this endpoint, which means it may change. Once it's stable, we'll remove the 'beta' label.
     */
    get: operations['get_roles_api_v1_organization__organization_id__roles_get'];
    put?: never;
    /**
     * Add Role
     *
     *     [beta]
     * @description Adds a role to the specified organization. We're still working on this endpoint, which means it may change. Once it's stable, we'll remove the 'beta' label.
     */
    post: operations['add_role_api_v1_organization__organization_id__roles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/organization/{organization_id}/roles/{role_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Update Role
     *
     *     [beta]
     * @description Adds a role to the specified organization. We're still working on this endpoint, which means it may change. Once it's stable, we'll remove the 'beta' label.
     */
    put: operations['update_role_api_v1_organization__organization_id__roles__role_id__put'];
    post?: never;
    /**
     * Delete Role
     *
     *     [beta]
     * @description Deletes a role from the specified organization. We're still working on this endpoint, which means it may change. Once it's stable, we'll remove the 'beta' label.
     */
    delete: operations['delete_role_api_v1_organization__organization_id__roles__role_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/organization/{organization_id}/support_request': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Support Request
     * @description Reach out to our support team for help with your issue.
     */
    post: operations['create_support_request_api_v1_organization__organization_id__support_request_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/pipeline-utils/yaml-integrate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Generate Integrated Pipeline Yaml */
    post: operations['generate_integrated_pipeline_yaml_api_v1_pipeline_utils_yaml_integrate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/public_prompt_templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Public Prompt Templates
     * @description Lists public prompt templates available in Prompt Studio.
     */
    get: operations['list_public_prompt_templates_api_v1_public_prompt_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Tokens
     * @description Returns all API keys present in deepset AI Platform together with their properties.
     */
    get: operations['get_tokens_api_v1_token_get'];
    put?: never;
    /**
     * Create Token
     * @description Creates the API key that you can use to connect deepset AI Platform to your application.
     */
    post: operations['create_token_api_v1_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/token/{api_token_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieve Token
     * @description Returns the API key with the ID you specify. This ID can be obtained by calling the list endpoint of this resource.
     */
    get: operations['retrieve_token_api_v1_token__api_token_id__get'];
    put?: never;
    post?: never;
    /**
     * Remove Token
     * @description Deletes the API key with the ID you specify.
     */
    delete: operations['remove_token_api_v1_token__api_token_id__delete'];
    options?: never;
    head?: never;
    /**
     * Patch Token
     * @description Updates the name of a token in the database.
     */
    patch: operations['patch_token_api_v1_token__api_token_id__patch'];
    trace?: never;
  };
  '/api/v1/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Users
     * @description Retrieve the properties of all user objects in your organization.
     */
    get: operations['get_users_api_v1_users_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/users/{user_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User
     * @description Retrieve the properties of the specified user.
     */
    get: operations['get_user_api_v1_users__user_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete User
     * @description Deletes a user from deepset AI Platform.
     */
    delete: operations['delete_user_api_v1_users__user_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update User Permission
     * @description Update user permissions.
     */
    patch: operations['update_user_permission_api_v1_users__user_id__patch'];
    trace?: never;
  };
  '/api/v1/users/{user_id}/assign': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Assign Role
     * @deprecated
     */
    post: operations['assign_role_api_v1_users__user_id__assign_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/users/{user_id}/roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Assign Role */
    post: operations['assign_role_api_v1_users__user_id__roles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/users/{user_id}/unassign': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Remove Role */
    post: operations['remove_role_api_v1_users__user_id__unassign_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Workspaces
     * @description Lists all deepset workspaces and their properties.
     */
    get: operations['list_workspaces_api_v1_workspaces_get'];
    put?: never;
    /**
     * Create Workspace
     * @description Creates a workspace within an organization.
     */
    post: operations['create_workspace_api_v1_workspaces_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Workspace
     * @description Returns the specified workspace and its properties.
     */
    get: operations['get_workspace_api_v1_workspaces__workspace_name__get'];
    put?: never;
    post?: never;
    /**
     * Delete Workspace
     * @description Deletes a workspace and everything that is associated with it. Be careful as this action cannot be undone.
     */
    delete: operations['delete_workspace_api_v1_workspaces__workspace_name__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/datasets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Datasets
     * @description Lists all datasets in a workspace with their associated files.
     *     Supports pagination.
     */
    get: operations['list_datasets_api_v1_workspaces__workspace_name__datasets_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/datasets/{dataset_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Files
     * @description Adds files to a dataset by calling the file service's add_file method for each file.
     */
    post: operations['add_files_api_v1_workspaces__workspace_name__datasets__dataset_name__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/files': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Files
     * @description Lists files in a workspace. This endpoint supports pagination and filtering by name and metadata.
     */
    get: operations['list_files_api_v1_workspaces__workspace_name__files_get'];
    put?: never;
    /**
     * Upload File
     * @description Uploads a file into the workspace. You can also use this endpoint to create a text file. To do that, enter the file name and text as its contents.
     */
    post: operations['upload_file_api_v1_workspaces__workspace_name__files_post'];
    /**
     * Delete Files
     * @description Deletes files specified in the `names` parameter from a workspace. If `names` is empty, it deletes all files.
     */
    delete: operations['delete_files_api_v1_workspaces__workspace_name__files_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/files/_search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Search Files
     * @description Executes an OpenSearch query on the workspace's file index and returns the raw response. The query must follow the [OpenSearch Query DSL syntax](https://opensearch.org/docs/latest/query-dsl/).
     */
    post: operations['search_files_api_v1_workspaces__workspace_name__files__search_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/files/update-meta': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Update File Meta Bulk
     * @description Updates the metadata of the files and of the documents created from these files. You can modify existing metadata or add new ones. If you send a new metadata dictionary, it's merged with the existing dictionary. To change the value of an existing key, pass this key with the new value. To add a new key:value pair, simply pass it in the request. It will add the new metadata and keep the existing ones. To delete a key:value pair, pass the key with `None` as value, for example: "author":"None". (But to fully delete all metadata, upload the file again.)
     */
    post: operations['update_file_meta_bulk_api_v1_workspaces__workspace_name__files_update_meta_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/files/{file_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get File
     * @description Retrieves the file contents.
     */
    get: operations['get_file_api_v1_workspaces__workspace_name__files__file_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete File
     * @description Removes the file from the workspace.
     */
    delete: operations['delete_file_api_v1_workspaces__workspace_name__files__file_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/files/{file_id}/meta': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get File Meta
     * @description Displays the metadata of a file.
     */
    get: operations['get_file_meta_api_v1_workspaces__workspace_name__files__file_id__meta_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update File Meta
     * @description Updates the metadata of a file and of the documents created from this file. You can modify existing metadata or add new ones. If you send a new metadata dictionary, it's merged with the existing dictionary. To change the value of an existing key, pass this key with the new value. To add a new key:value pair, simply pass it in the request. It will add the new metadata and keep the existing ones. To delete a key:value pair, pass the key with `None` as value, for example: "author":"None". (But to fully delete all metadata, upload the file again.)
     */
    patch: operations['update_file_meta_api_v1_workspaces__workspace_name__files__file_id__meta_patch'];
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Indexes */
    get: operations['get_indexes_api_v1_workspaces__workspace_name__indexes_get'];
    put?: never;
    /**
     * Create Index
     * @description Creates a new pipeline index.
     */
    post: operations['create_index_api_v1_workspaces__workspace_name__indexes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Index By Name
     * @description Get a single pipeline index by ID.
     */
    get: operations['get_index_by_name_api_v1_workspaces__workspace_name__indexes__index_name__get'];
    put?: never;
    post?: never;
    /**
     * Delete Index
     * @description Deletes a pipeline index.
     */
    delete: operations['delete_index_api_v1_workspaces__workspace_name__indexes__index_name__delete'];
    options?: never;
    head?: never;
    /**
     * Update Index
     * @description Updates specific fields of a pipeline index. Only description can be updated while the index is deployed.
     *     To update name or config_yaml, the index must be undeployed.
     */
    patch: operations['update_index_api_v1_workspaces__workspace_name__indexes__index_name__patch'];
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/deploy': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Deploy Index
     * @description Deploys a pipeline index to deepset.
     */
    post: operations['deploy_index_api_v1_workspaces__workspace_name__indexes__index_name__deploy_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/documents-count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Count Documents
     * @description Counts the number of documents in the pipeline.
     */
    get: operations['count_documents_api_v1_workspaces__workspace_name__indexes__index_name__documents_count_get'];
    put?: never;
    /**
     * Count Documents Deprecated
     * @deprecated
     * @description Counts the number of documents in the pipeline.
     *
     *     **Note**: This endpoint will be deprecated on 1st April 2025.
     *     Migrate to the [Count Documents](https://docs.cloud.deepset.ai/reference/count_documents_api_v1_workspaces__workspace_name__indexes__index_name__documents_count_get)
     *     endpoint before that.
     */
    post: operations['count_documents_deprecated_api_v1_workspaces__workspace_name__indexes__index_name__documents_count_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/documents-query': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Query Documents
     * @description Searches the documents for the specified query.
     */
    post: operations['query_documents_api_v1_workspaces__workspace_name__indexes__index_name__documents_query_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/documents-stream': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get All Documents Stream
     * @description Returns all documents created for a pipeline.
     */
    post: operations['get_all_documents_stream_api_v1_workspaces__workspace_name__indexes__index_name__documents_stream_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Document
     * @description Displays the document content and its properties.
     */
    get: operations['get_document_api_v1_workspaces__workspace_name__indexes__index_name__documents__document_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/files': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Indexed Files By Status
     * @description Returns IDs of all files with a specific status and processed by a specified index.
     */
    get: operations['get_indexed_files_by_status_api_v1_workspaces__workspace_name__indexes__index_name__files_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/files/{file_id}/reindex': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Schedule Single File For Indexing
     * @description Reindexes a single file on a pipeline index.
     */
    post: operations['schedule_single_file_for_indexing_api_v1_workspaces__workspace_name__indexes__index_name__files__file_id__reindex_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/logs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Index Logs
     * @description Fetches pipeline index logs as JSON or CSV.
     */
    get: operations['get_pipeline_index_logs_api_v1_workspaces__workspace_name__indexes__index_name__logs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/undeploy': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Undeploy Index
     * @description Disables a pipeline index in deepset.
     */
    post: operations['undeploy_index_api_v1_workspaces__workspace_name__indexes__index_name__undeploy_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/indexes/{index_name}/visualization': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Pipeline Visualization */
    get: operations['get_pipeline_visualization_api_v1_workspaces__workspace_name__indexes__index_name__visualization_get'];
    /** Update Pipeline Visualization */
    put: operations['update_pipeline_visualization_api_v1_workspaces__workspace_name__indexes__index_name__visualization_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipeline_templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Pipeline Templates
     * @description Retrieves the list of the pipeline templates.
     */
    get: operations['list_pipeline_templates_api_v1_workspaces__workspace_name__pipeline_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipeline_templates/{pipeline_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Template
     * @description Return pipeline template by pipeline_name.
     */
    get: operations['get_pipeline_template_api_v1_workspaces__workspace_name__pipeline_templates__pipeline_name__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipeline_validations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Validate Pipeline
     * @description Validates a pipeline YAML. Use this endpoint to validate your pipeline configuration before saving it.
     */
    post: operations['validate_pipeline_api_v1_workspaces__workspace_name__pipeline_validations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Pipelines
     * @description Lists all the pipelines in the workspace.
     */
    get: operations['list_pipelines_api_v1_workspaces__workspace_name__pipelines_get'];
    put?: never;
    /**
     * Create Pipeline
     * @description Creates a pipeline YAML file.
     */
    post: operations['create_pipeline_api_v1_workspaces__workspace_name__pipelines_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline
     * @description Returns a pipeline.
     */
    get: operations['get_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__get'];
    put?: never;
    post?: never;
    /**
     * Delete Pipeline
     * @description Removes a pipeline from deepset within the specified workspace.
     */
    delete: operations['delete_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__delete'];
    options?: never;
    head?: never;
    /**
     * Update Pipeline
     * @description Updates the pipeline name, service level (development or production), or status.
     *
     *     Search users have permission to change pipeline status only.
     */
    patch: operations['update_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__patch'];
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Activate Pipeline
     * @description Activates the pipeline.
     */
    post: operations['activate_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__activate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/chat': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Chat
     * @description Run a chat query. Chat pipelines are based on the `chat` template that uses a search session to include search
     *     history in the chat. You can then specify how many search history items (query and answer) from a given search
     *     session you want to display in the chat. You'll need a search session ID to run the query. Use the search session
     *      endpoints to list or create search sessions.
     */
    post: operations['chat_api_v1_workspaces__workspace_name__pipelines__pipeline_name__chat_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/chat-stream': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Chat Stream
     * @description Run a chat query and return the answer as stream. Chat pipelines are based on the `chat` template that uses a search
     *     session to include search history in the chat. You can then specify how many search history items (query and answer)
     *     from a given search session you want to display in the chat. You'll need a search session ID to run the query.
     *     Use the search session endpoints to list or create search sessions.
     *
     *     The full result can be accessed as the last stream message if `include_result=True`.
     *
     *     Event data format where `delta`, `result` and `error` are mutually exclusive:
     *     ```
     *     {
     *         "query_id": UUID,
     *         "type": Literal["delta", "result", "error"],
     *         "delta": Optional[StreamDelta],
     *         "result": Optional[DeepsetCloudQueryResponse],
     *         "error": Optional[str],
     *     }
     *     ```
     *
     *     StreamDelta format:
     *     ```
     *     {
     *         "text": str,
     *     }
     *     ```
     *
     *         Example code to consume the stream in Python:
     *     ```python
     *     import httpx
     *     import json
     *     from httpx_sse import EventSource
     *     import asyncio
     *
     *     TOKEN = "MY_TOKEN"
     *     PIPELINE_URL = "https://api.cloud.deepset.ai/api/v1/workspaces/MY_WORKSPACE/pipelines/MY_PIPELINE"
     *     SEARCH_SESSION_ID = "MY_SEARCH_SESSION_ID"
     *
     *
     *     async def main():
     *         query = {
     *             "query": "How does streaming work with deepset?",
     *             "include_result": True,
     *             "search_session_id": SEARCH_SESSION_ID
     *         }
     *         headers = {
     *             "Authorization": f"Bearer {TOKEN}"
     *         }
     *         async with httpx.AsyncClient(base_url=PIPELINE_URL, headers=headers) as client:
     *             async with client.stream("POST", "/chat-stream", json=query) as response:
     *                 # Check if the response is successful
     *                 if response.status_code != 200:
     *                     await response.aread()
     *                     print(f"An error occured with status code: {response.status_code}")
     *                     print(response.json()["errors"][0])
     *                     return
     *
     *                 event_source = EventSource(response)
     *                 # Stream the response
     *                 async for event in event_source.aiter_sse():
     *                     event_data = json.loads(event.data)
     *                     chunk_type = event_data["type"]
     *                     # Check the type of the chunk and print the data accordingly
     *                     match chunk_type:
     *                         # Delta chunk contains the next text chunk of the answer
     *                         case "delta":
     *                             token: str = event_data["delta"]["text"]
     *                             print(token, flush=True, end="")
     *                         # Result chunk contains the final pipeline result
     *                         case "result":
     *                             print("\n\nPipeline result:")
     *                             print(json.dumps(event_data["result"]))
     *                         # Error chunk contains the error message
     *                         case "error":
     *                             print("\n\nAn error occurred while streaming:")
     *                             print(event_data["error"])
     *
     *
     *     asyncio.run(main())
     *     ```
     */
    post: operations['chat_stream_api_v1_workspaces__workspace_name__pipelines__pipeline_name__chat_stream_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/default': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Set Default Pipeline
     * @description Sets a pipeline as the default pipeline for search.
     */
    post: operations['set_default_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__default_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/deploy': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Deploy Pipeline
     * @description Deploys a pipeline in deepset.
     */
    post: operations['deploy_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__deploy_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/issues': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Issues
     * @description Fetches pipeline runtime issues from pipeline logs.
     */
    get: operations['get_pipeline_issues_api_v1_workspaces__workspace_name__pipelines__pipeline_name__issues_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/logs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Logs
     * @description Fetches pipeline logs as JSON or CSV.
     */
    get: operations['get_pipeline_logs_api_v1_workspaces__workspace_name__pipelines__pipeline_name__logs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/meta': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Index Metadata
     * @description Returns metadata from an index used by a pipeline's.
     *     For multi-index pipelines, the first found index's metadata is returned.
     */
    get: operations['get_pipeline_index_metadata_api_v1_workspaces__workspace_name__pipelines__pipeline_name__meta_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/meta/{field_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Metadata Field Values
     * @description Returns metadata field values for a specified key across all files of a pipeline's connected index.
     *
     *     Specify the metadata field key and the pipeline and workspace names to retrieve the corresponding values for
     *     each file.
     *     For multi-index pipelines, the first found index's metadata is searched.
     */
    get: operations['get_pipeline_metadata_field_values_api_v1_workspaces__workspace_name__pipelines__pipeline_name__meta__field_name__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/meta/{meta_field}/aggregation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Min Max Aggregation Metadata
     * @description Returns the minimum and maximum values of a metadata field for the connected index of a given pipeline.
     */
    get: operations['get_pipeline_min_max_aggregation_metadata_api_v1_workspaces__workspace_name__pipelines__pipeline_name__meta__meta_field__aggregation_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/prompt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Prompt
     * @description Returns the prompt of the pipeline.
     */
    get: operations['get_prompt_api_v1_workspaces__workspace_name__pipelines__pipeline_name__prompt_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/prompts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Prompts
     * @description Returns the prompts of the pipeline as a dictionary of prompt node names and their respective prompts.
     */
    get: operations['get_prompts_api_v1_workspaces__workspace_name__pipelines__pipeline_name__prompts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Search
     * @description Run a search using a pipeline.
     */
    post: operations['search_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/search-stream': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Search Stream
     * @description Run a search using a pipeline and return the answer as stream.
     *
     *     The full result can be accessed as the last stream message if `include_result=True`.
     *
     *     Event data format where `delta`, `result` and `error` are mutually exclusive:
     *     ```
     *     {
     *         "query_id": UUID,
     *         "type": Literal["delta", "result", "error"],
     *         "delta": Optional[StreamDelta],
     *         "result": Optional[DeepsetCloudQueryResponse],
     *         "error": Optional[str],
     *     }
     *     ```
     *
     *     StreamDelta format:
     *     ```
     *     {
     *         "text": str,
     *     }
     *     ```
     *
     *     Example code to consume the stream in Python:
     *     ```python
     *     import httpx
     *     import json
     *     from httpx_sse import EventSource
     *     import asyncio
     *
     *     TOKEN = "MY_TOKEN"
     *     PIPELINE_URL = "https://api.cloud.deepset.ai/api/v1/workspaces/MY_WORKSPACE/pipelines/MY_PIPELINE"
     *
     *
     *     async def main():
     *         query = {
     *             "query": "How does streaming work with deepset?",
     *             "include_result": True
     *         }
     *         headers = {
     *             "Authorization": f"Bearer {TOKEN}"
     *         }
     *         async with httpx.AsyncClient(base_url=PIPELINE_URL, headers=headers) as client:
     *             async with client.stream("POST", "/search-stream", json=query) as response:
     *                 # Check if the response is successful
     *                 if response.status_code != 200:
     *                     await response.aread()
     *                     print(f"An error occured with status code: {response.status_code}")
     *                     print(response.json()["errors"][0])
     *                     return
     *
     *                 event_source = EventSource(response)
     *                 # Stream the response
     *                 async for event in event_source.aiter_sse():
     *                     event_data = json.loads(event.data)
     *                     chunk_type = event_data["type"]
     *                     # Check the type of the chunk and print the data accordingly
     *                     match chunk_type:
     *                         # Delta chunk contains the next text chunk of the answer
     *                         case "delta":
     *                             token: str = event_data["delta"]["text"]
     *                             print(token, flush=True, end="")
     *                         # Result chunk contains the final pipeline result
     *                         case "result":
     *                             print("\n\nPipeline result:")
     *                             print(json.dumps(event_data["result"]))
     *                         # Error chunk contains the error message
     *                         case "error":
     *                             print("\n\nAn error occurred while streaming:")
     *                             print(event_data["error"])
     *
     *
     *     asyncio.run(main())
     *     ```
     */
    post: operations['search_stream_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_stream_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/search_history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Pipeline Search History
     * @description Returns the last 100 items from search history which includes information such as the query, the answer,
     *     the pipeline used, and more.
     *
     *     If you need to retrieve more than 100 items, use the
     *     [Pipeline Search History Archive](https://docs.cloud.deepset.ai/reference/pipeline_search_history_archive_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_history_archive_get)
     *      endpoint.
     */
    get: operations['pipeline_search_history_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_history_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/search_history_archive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Pipeline Search History Archive
     * @description Retrieves pipeline's complete search history sorted by the most recent items first.
     *
     *     Pipeline's search history is only available 30 minutes after completing a search request.
     *     To retrieve recent search history, use the
     *     [Pipeline Search History](https://docs.cloud.deepset.ai/reference/pipeline_search_history_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_history_get)
     *     endpoint.
     */
    get: operations['pipeline_search_history_archive_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_history_archive_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Stats
     * @description Returns pipeline statistics.
     */
    get: operations['get_pipeline_stats_api_v1_workspaces__workspace_name__pipelines__pipeline_name__stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/undeploy': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Undeploy Pipeline
     * @description Undeploys a pipeline in deepset. Undeployed pipelines cannot be used for search.
     */
    post: operations['undeploy_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__undeploy_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/visualization': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Pipeline Visualization */
    get: operations['get_pipeline_visualization_api_v1_workspaces__workspace_name__pipelines__pipeline_name__visualization_get'];
    /** Update Pipeline Visualization */
    put: operations['update_pipeline_visualization_api_v1_workspaces__workspace_name__pipelines__pipeline_name__visualization_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/pipelines/{pipeline_name}/yaml': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Yaml Configs
     * @description Displays the pipeline YAML configurations.
     */
    get: operations['get_pipeline_yaml_configs_api_v1_workspaces__workspace_name__pipelines__pipeline_name__yaml_get'];
    /**
     * Update Pipeline Yaml
     * @description Updates the pipeline YAML file.
     */
    put: operations['update_pipeline_yaml_api_v1_workspaces__workspace_name__pipelines__pipeline_name__yaml_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/prompt_templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Prompt Templates
     * @description Retrieves the list of prompt templates for the given workspace.
     */
    get: operations['list_prompt_templates_api_v1_workspaces__workspace_name__prompt_templates_get'];
    put?: never;
    /**
     * Create Prompt Template
     * @description Creates a prompt template. The template is saved under custom templates in Prompt Studio.
     */
    post: operations['create_prompt_template_api_v1_workspaces__workspace_name__prompt_templates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/prompt_templates/{prompt_template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Update Prompt Template
     * @description Updates the prompt template with the given ID.
     */
    put: operations['update_prompt_template_api_v1_workspaces__workspace_name__prompt_templates__prompt_template_id__put'];
    post?: never;
    /**
     * Delete Prompt Templates
     * @description Deletes the prompt template with the given ID.
     */
    delete: operations['delete_prompt_templates_api_v1_workspaces__workspace_name__prompt_templates__prompt_template_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/search_count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Count
     * @description Returns the number of search requests per day for the last 10 days.
     */
    get: operations['search_count_api_v1_workspaces__workspace_name__search_count_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/search_history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search History
     * @description Returns the search history for a workspace. The history includes information such as the query, the answer,
     *     the pipeline used, and more.
     */
    get: operations['search_history_api_v1_workspaces__workspace_name__search_history_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/search_sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Search Sessions
     * @description Returns all search sessions. Search sessions are used in chat as chat history.
     */
    get: operations['get_search_sessions_api_v1_workspaces__workspace_name__search_sessions_get'];
    put?: never;
    /**
     * Create Search Session
     * @description Creates a search session you can later use in chat as chat history.
     */
    post: operations['create_search_session_api_v1_workspaces__workspace_name__search_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/search_sessions/{search_session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Search Session
     * @description Delete a search session together with its search history.
     */
    delete: operations['delete_search_session_api_v1_workspaces__workspace_name__search_sessions__search_session_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/shared_prototypes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Prototypes
     * @description Lists active shared prototypes.
     */
    get: operations['list_prototypes_api_v1_workspaces__workspace_name__shared_prototypes_get'];
    put?: never;
    /**
     * Create Prototype
     * @description Creates a link to a pipeline prototype you can then share with others to try out.
     */
    post: operations['create_prototype_api_v1_workspaces__workspace_name__shared_prototypes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/shared_prototypes/{shared_prototype_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Shared Prototype
     * @description Returns the shared pipeline prototype by ID.
     */
    get: operations['get_shared_prototype_api_v1_workspaces__workspace_name__shared_prototypes__shared_prototype_id__get'];
    put?: never;
    post?: never;
    /**
     * Revoke Shared Prototype
     * @description Revokes a shared pipeline prototype. Once you revoke a prototype, users can no longer access it.
     */
    delete: operations['revoke_shared_prototype_api_v1_workspaces__workspace_name__shared_prototypes__shared_prototype_id__delete'];
    options?: never;
    head?: never;
    /**
     * Edit Shared Prototype
     * @description Updates the shared prototype description and file options.
     */
    patch: operations['edit_shared_prototype_api_v1_workspaces__workspace_name__shared_prototypes__shared_prototype_id__patch'];
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Workspace Stats
     * @description Displays the number of files and documents in a workspace, the number of search requests, and the average response time.
     */
    get: operations['get_workspace_stats_api_v1_workspaces__workspace_name__stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/temporary_files': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Temporary File
     * @description Uploads a file into the workspace. You can also use this endpoint to create a text file. To do that, enter the file name and text as its contents.
     */
    post: operations['upload_temporary_file_api_v1_workspaces__workspace_name__temporary_files_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/temporary_files/{file_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Temporary File
     * @description Retrieves the file contents of temporary files.
     *
     *     :param session: The database session.
     *     :param file_id: The ID of the file to retrieve.
     *     :param workspace: The workspace from which to retrieve the file.
     */
    get: operations['get_temporary_file_api_v1_workspaces__workspace_name__temporary_files__file_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/upload_sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Upload Sessions
     * @description Returns a list of all active upload sessions.
     */
    get: operations['get_upload_sessions_api_v1_workspaces__workspace_name__upload_sessions_get'];
    put?: never;
    /**
     * Create Upload Session
     * @description Creates a session for uploading files and file metadata. The session remains active for 24 hours. You can upload up to 10 000 files in a session.
     */
    post: operations['create_upload_session_api_v1_workspaces__workspace_name__upload_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/upload_sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Status
     * @description Displays the details of a session. Use this endpoint to check the status of the files in a session or the session
     *     expiration date.
     */
    get: operations['get_session_status_api_v1_workspaces__workspace_name__upload_sessions__session_id__get'];
    /**
     * Close Session
     * @description Closes the session and starts the ingestion process.
     *     If the session is not closed explicitly, the session will be automatically closed after 24 hours.
     */
    put: operations['close_session_api_v1_workspaces__workspace_name__upload_sessions__session_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/workspaces/{workspace_name}/upload_sessions/{session_id}/files': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Files
     * @description Displays the file details of a session. Use this endpoint to check the status of the files in a session or the session expiration date.
     */
    get: operations['get_session_files_api_v1_workspaces__workspace_name__upload_sessions__session_id__files_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/custom_components': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Custom Components
     * @description Get a list of custom components currently uploaded to deepset Cloud.
     *     The list includes all the details of each component, such as its status and version.
     */
    get: operations['get_custom_components_api_v2_custom_components_get'];
    put?: never;
    /**
     * Import Custom Components
     * @description Imports a custom component as a zip file.
     *     Use the [Custom component template](https://github.com/deepset-ai/dc-custom-component-template)
     *     to write your component, and then upload the zipped template.
     */
    post: operations['import_custom_components_api_v2_custom_components_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/custom_components/logs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Custom Component Logs
     * @description Get custom component installation logs as plain text.
     */
    get: operations['get_custom_component_logs_api_v2_custom_components_logs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/custom_components/{custom_component_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Custom Component
     * @description Get the details of a custom component with a specific ID. The details include the component version and status.
     *     You may need to use the Get Custom Components endpoint first to obtain the component's ID.
     */
    get: operations['get_custom_component_api_v2_custom_components__custom_component_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/secrets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Secrets
     * @description Returns the existing secrets.
     */
    get: operations['get_secrets_api_v2_secrets_get'];
    put?: never;
    /**
     * Create Secret
     * @description Imports your secret and saves it in deepset AI Platform.
     */
    post: operations['create_secret_api_v2_secrets_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/secrets/{secret_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Secret
     * @description Returns the secret with the given id.
     */
    get: operations['get_secret_api_v2_secrets__secret_id__get'];
    put?: never;
    post?: never;
    /**
     * Remove Secret
     * @description Deletes a secret from deepset AI Platform.
     */
    delete: operations['remove_secret_api_v2_secrets__secret_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/debug-tunnel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start Debug Tunnel
     * @description Start a debug tunnel for a pipeline.
     *
     *     If another debug tunnel is already running for this pipeline, the existing tunnel will be stopped and a new one will
     *     be started.
     */
    post: operations['start_debug_tunnel_api_v2_workspaces__workspace_id__pipelines__pipeline_id__debug_tunnel_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Paginated Feedback
     * @description Retrieves a paginated list of user feedback.
     *     Use this endpoint to fetch batches of feedback entries, sorted and filtered according to your preference.
     */
    get: operations['get_paginated_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback_get'];
    put?: never;
    /**
     * Create Feedback
     * @description Adds user feedback to a specific response.
     *     Use this endpoint to collect and store user ratings, comments, "
     *     "or other feedback about the quality or relevance of a response.
     */
    post: operations['create_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/feedback/export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Feedback
     * @description Exports feedback to a csv file.
     */
    get: operations['export_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback_export_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/feedback/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pipeline Feedback Stats
     * @description Return feedback stats for a pipeline.
     */
    get: operations['get_pipeline_feedback_stats_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/feedback/{feedback_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Feedback
     * @description Deletes a feedback entry. You can't bring back a deleted feedback entry.
     */
    delete: operations['delete_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback__feedback_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Feedback
     * @description Modifies and existing feedback entry.
     *     Use this endpoint to update the content and rating of a specific piece of user feedback.
     */
    patch: operations['update_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback__feedback_id__patch'];
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/search_history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Pipeline Search History
     * @description Deletes all search history for a specific pipeline.
     *     Deletion is done in the background and may take a few seconds to take effect.
     */
    delete: operations['delete_pipeline_search_history_api_v2_workspaces__workspace_id__pipelines__pipeline_id__search_history_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/search_history/{query_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Pipeline Search History Result
     * @description Returns the search history for a specific query_id.
     */
    get: operations['pipeline_search_history_result_api_v2_workspaces__workspace_id__pipelines__pipeline_id__search_history__query_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/tags': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Paginated Tags
     * @description Retrieves a paginated list of tags.
     *     Use this endpoint to fetch batches of feedback entries, "
     *     "sorted and filtered according to your preference.
     */
    get: operations['get_paginated_tags_api_v2_workspaces__workspace_id__pipelines__pipeline_id__tags_get'];
    put?: never;
    /**
     * Create Tags
     * @description Creates tags for a specified pipeline.
     *     Users will be able to choose these tags when giving feedback "
     *     "on reponses generated by this pipeline.
     *     Use tags to structure and categorize user feedback.
     */
    post: operations['create_tags_api_v2_workspaces__workspace_id__pipelines__pipeline_id__tags_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/workspaces/{workspace_id}/pipelines/{pipeline_id}/tags/{tag_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Tags
     * @description Permanently deletes tags with the given IDs. You can only delete tags that aren't connected to feedback entries.
     */
    delete: operations['delete_tags_api_v2_workspaces__workspace_id__pipelines__pipeline_id__tags__tag_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/health': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Health
     * @description Checks if the API and database connection work correctly.
     *
     *     It is enough to use the Depends, since we configured the database with `pre_ping`.
     *     Therefore the creation of the session will fail if the DB is not available.
     */
    get: operations['health_health_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** APITokenResult */
    APITokenResult: {
      /**
       * API Token
       * @description API token with the prefix `api_`. This token inherits all permissions of the user that created it, and acts on behalf of this user.
       */
      api_token: string;
    };
    /** AWSAssumeRoleCredentials */
    AWSAssumeRoleCredentials: {
      /**
       * Role ARN
       * @description The role which deepset AI Platform should assume to access your bucket.
       */
      role_arn: string;
      /**
       * Role Session Name
       * @description The identifier for the assumed role session which deepset AI Platform uses to access your bucket.
       */
      role_session_name: string;
    };
    /**
     * Action
     * @description Actions are the operations that can be performed on an asset.
     *     Currently defined actions are:
     *     - read
     *     - write
     *
     *     When allowing write we assume that users can also read.
     *     This is a simplification that we can revisit later.
     * @enum {string}
     */
    Action: Action;
    /** AddRoleBody */
    AddRoleBody: {
      /**
       * Description
       * @description The description of the role
       */
      description: string;
      /**
       * Permissions
       * @description The permissions of the role
       */
      permissions: components['schemas']['Permission'][];
      /**
       * Role Name
       * @description The name of the role
       */
      role_name: string;
    };
    /**
     * AssetCollection
     * @description Collection of all assets with their information.
     */
    AssetCollection: {
      /** Assets */
      assets: components['schemas']['AssetInfo'][];
    };
    /**
     * AssetInfo
     * @description Information about an asset including its name, description and allowed actions.
     */
    AssetInfo: {
      /** Actions */
      actions: components['schemas']['Action'][];
      asset: components['schemas']['Assets'];
      /** Description */
      description: string;
    };
    /**
     * Assets
     * @description Assets are the resources that are protected by the authorization system.
     *     Currently defined assets are:
     *     - pipelines
     *     - files
     *     - prompts
     *     - secrets
     *     - jobs
     *     - indexes
     *     - pipeline_templates
     * @enum {string}
     */
    Assets: Assets;
    /** AssignedRoleRequest */
    AssignedRoleRequest: {
      /**
       * User Role
       * @description Role of the user. This can be a custom role or one of the default roles.
       */
      role: components['schemas']['Roles'] | string;
      /**
       * Workspace Name
       * @description Name of the workspace.
       */
      workspace_name: string;
    };
    /** Body_import_custom_components_api_v2_custom_components_post */
    Body_import_custom_components_api_v2_custom_components_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_upload_file_api_v1_workspaces__workspace_name__files_post */
    Body_upload_file_api_v1_workspaces__workspace_name__files_post: {
      /**
       * File
       * @description The name of the file you want to upload.
       */
      file?: string | null;
      /**
       * Meta
       * @description A list of metadata fields in the "key":"value" format. During search, you can use these metadata as filters.
       * @default {}
       */
      meta: string;
      /**
       * Text
       * @description Instead of uploading a file, you can paste the file contents here to create a text file.
       */
      text?: string | null;
    };
    /** Body_upload_temporary_file_api_v1_workspaces__workspace_name__temporary_files_post */
    Body_upload_temporary_file_api_v1_workspaces__workspace_name__temporary_files_post: {
      /**
       * File
       * @description The name of the file you want to upload.
       */
      file?: string | null;
      /**
       * Meta
       * @description A list of metadata fields in the "key":"value" format. During search, you can use these metadata as filters.
       * @default {}
       */
      meta: string;
      /**
       * Text
       * @description Instead of uploading a file, you can paste the file contents here to create a text file.
       */
      text?: string | null;
    };
    /** ChatQuery */
    ChatQuery: {
      /**
       * Chat History Limit
       * @description The number of the most recent chat history items to include in the chat. For example, setting the limit to 3 will show the last three
       * @default 3
       */
      chat_history_limit: number;
      /**
       * Debug Flag
       * @description Shows debug output for the pipeline (for example, prompt).
       * @default false
       */
      debug: boolean | null;
      /**
       * Files
       * @description A list of files in the workspace.
       */
      files?: components['schemas']['FileId'][] | null;
      /**
       * Haystack Filters
       * @description Filters you can use to narrow down the search. For more information, see [filtering logic](https://docs.cloud.deepset.ai/docs/filtering-logic).
       */
      filters?:
        | components['schemas']['LogicalCondition']
        | components['schemas']['ComparisonCondition']
        | components['schemas']['EmptyFilters']
        | null;
      /**
       * Pipeline Parameters
       * @description Parameters you can use to customize the pipeline. For details, see [Haystack documentation for the pipeline `run()` method](https://docs.haystack.deepset.ai/reference/pipeline-api). These filters can be used to pass additional parameters to the pipeline.(Haystack is the underlying technology for deepset.)
       */
      params?: {
        [key: string]: unknown;
      } | null;
      /**
       * Queries
       * @description A list of queries you want to run through the pipeline.
       */
      queries: string[];
      /**
       * Search Session ID
       * Format: uuid
       * @description The ID of the search session you want to use for chat.
       */
      search_session_id: string;
      /**
       * View prompts
       * @description Adds the runtime prompts of all nodes to the response. (Pipeline runs in debug mode.)
       * @default false
       */
      view_prompts: boolean;
    };
    /** ChatStreamingQuery */
    ChatStreamingQuery: {
      /**
       * Chat History Limit
       * @description The number of the most recent chat history items to include in the chat. For example, setting the limit to 3 will show the last three
       * @default 3
       */
      chat_history_limit: number;
      /**
       * Debug Flag
       * @description Shows debug output for the pipeline (for example, prompt).
       * @default false
       */
      debug: boolean | null;
      /**
       * Files
       * @description A list of files in the workspace.
       */
      files?: string[] | null;
      /**
       * Haystack Filters
       * @description Filters you can use to narrow down the search. For more information, see [filtering logic](https://docs.cloud.deepset.ai/docs/filtering-logic).
       */
      filters?:
        | components['schemas']['LogicalCondition']
        | components['schemas']['ComparisonCondition']
        | components['schemas']['EmptyFilters']
        | null;
      /**
       * Include Result
       * @description Includes the result of the pipeline at the end of the stream under key 'result'.
       * @default false
       */
      include_result: boolean;
      /**
       * Pipeline Parameters
       * @description Parameters you can use to customize the pipeline. For details, see [Haystack documentation for the pipeline `run()` method](https://docs.haystack.deepset.ai/reference/pipeline-api). These filters can be used to pass additional parameters to the pipeline.(Haystack is the underlying technology for deepset.)
       */
      params?: {
        [key: string]: unknown;
      } | null;
      /**
       * Query
       * @description The search query.
       */
      query: string;
      /**
       * Search Session ID
       * Format: uuid
       * @description The ID of the search session you want to use for chat.
       */
      search_session_id: string;
      /**
       * View prompts
       * @description Adds the runtime prompts of all nodes to the response. (Pipeline runs in debug mode.)
       * @default false
       */
      view_prompts: boolean;
    };
    /** CloseSession */
    CloseSession: {
      /**
       * Close Session
       * @description Closes the session and starts the ingestion of the uploaded files.
       * @default CLOSED
       * @constant
       */
      status: 'CLOSED';
    };
    /** ComparisonCondition */
    ComparisonCondition: {
      /**
       * Comparison Condition Field
       * @description The field you want to compare.
       */
      field: string;
      /**
       * Comparison Condition Operator
       * @description The operator you want to use for comparison.
       */
      operator: components['schemas']['ComparisonOperator'];
      /**
       * Comparison Condition Value
       * @description The value you want to compare the field to.
       */
      value: unknown;
    };
    /**
     * ComparisonOperator
     * @enum {string}
     */
    ComparisonOperator: ComparisonOperator;
    /**
     * ComponentDomain
     * @enum {string}
     */
    ComponentDomain: ComponentDomain;
    /** ComponentPosition */
    ComponentPosition: {
      /**
       * X-coordinate
       * @description X-coordinate of the component.
       */
      x: number;
      /**
       * Y-coordinate
       * @description Y-coordinate of the component.
       */
      y: number;
    };
    /** ComponentVisualizationMetadata */
    ComponentVisualizationMetadata: {
      /**
       * Component Position
       * @description Position of the component.
       */
      position: components['schemas']['ComponentPosition'];
    };
    /** CountDocumentsParams */
    CountDocumentsParams: Record<string, never>;
    /** CreateFeedback */
    CreateFeedback: {
      /** Bookmarked */
      bookmarked?: boolean | null;
      /** Comment */
      comment?: string | null;
      /** Feedback Id */
      feedback_id?: string | null;
      /**
       * Query Id
       * Format: uuid
       */
      query_id: string;
      /**
       * Result Id
       * Format: uuid
       */
      result_id: string;
      /** Score */
      score?: string | null;
      /** Tags */
      tags?: string[] | null;
    };
    /**
     * Create Registry Token
     * @example {
     *       "token": "your-aws-bedrock-token"
     *     }
     */
    CreateModelRegistryToken: {
      /**
       * Token
       * @description The model token.
       */
      token: string;
    };
    /** CreatePipeline */
    CreatePipeline: {
      /**
       * deepset Version
       * @description The version of deepset the pipeline was created with.
       * @default v2
       */
      deepset_cloud_version: components['schemas']['DeepsetCloudVersion'];
      /**
       * Indexing YAML
       * @description The deepset pipeline YAML configuration for indexing.
       */
      indexing_yaml?: string | null;
      /**
       * Pipeline Name
       * @description Name of the pipeline.
       */
      name: string;
      /**
       * Query YAML
       * @description The deepset pipeline YAML configuration for querying.
       */
      query_yaml?: string | null;
    };
    /** CreatePipelineIndexRequest */
    CreatePipelineIndexRequest: {
      /**
       * Pipeline Index Config YAML
       * @description Config YAML of the pipeline index.
       */
      config_yaml: string;
      /**
       * Pipeline Index Description
       * @description Description of the pipeline index.
       */
      description?: string | null;
      /**
       * Pipeline Index Name
       * @description Name of the pipeline index.
       */
      name: string;
    };
    /** Create Secret */
    CreateSecret: {
      /**
       * Secret Name
       * @description The name of the secret.
       */
      name: string;
      /**
       * Secret
       * @description The secret you want to add.
       */
      secret: string;
    };
    /** CreateSession */
    CreateSession: {
      /**
       * Upload session expiry
       * @description Timestamp when the upload session should expire, for example '2022-05-12T12:25:09+02:00'. This is an optional parameter. If not provided, the upload session will expire after the maximum expiry time of 24 hours.
       * @default 86400
       */
      expires_in_seconds: number | null;
      /**
       * Parallel Processing Enabled
       * @description Determines whether to process upload sessions in parallel. Use this option to speed up the ingestion process if the different sessions don't modify the same files.
       * @default false
       */
      parallel_processing_enabled: boolean;
      /**
       * Write Mode
       * @description Determines how to handle files that already exist. You can KEEP the existing file, OVERWRITE it, or FAIL to ingest if a file with the same name is already in your workspace.
       * @default KEEP
       */
      write_mode: components['schemas']['FileWriteModeEnum'];
    };
    /** CreateTag */
    CreateTag: {
      /** Name */
      name: string;
    };
    /** CreateToken */
    CreateToken: {
      /**
       * API Token Expires
       * @description Specifies whether the API token expires.
       * @default true
       */
      expires: boolean;
      /**
       * API Token Expiry
       * @description The date and time when the token expires. The timestamp is in the ISO 8601 format and follows the convention YYY-MM-DDTHH:MM:SS.sssZ. For more information, see [Date-Time](https://docs.cloud.deepset.ai/reference/api-best-practices#date-time).
       */
      expires_at?: string | null;
      /**
       * API Token Name
       * @description The name of the API token.
       */
      name?: string | null;
      /**
       * API Token type
       * @description Indicates if the API token is a personal or service level token.
       * @default true
       */
      personal: boolean;
      /**
       * API Token Role
       * @description The role of the API token. Defaults to the role of the user that created the token. Admin users can create tokens with any role.
       * @default EDITOR
       */
      role: components['schemas']['Roles'];
      /**
       * API Token Workspaces
       * @description The workspaces that the API token is associated with. Defaults to all workspaces that the user has access to.
       */
      workspaces?: string[];
    };
    /** CustomComponent */
    CustomComponent: {
      /**
       * Created by user ID
       * Format: uuid
       * @description User ID of the user who created the custom component.
       */
      created_by_user_id: string;
      /**
       * Custom component ID
       * Format: uuid
       * @description Unique identifier of the custom component.
       */
      custom_component_id: string;
      /**
       * Logs
       * @description Custom component logs.
       */
      logs: components['schemas']['CustomComponentLog'][];
      /**
       * Organization ID
       * Format: uuid
       * @description Unique identifier of the deepset Cloud organization with the organization where you want to upload the component.
       */
      organization_id: string;
      /**
       * Status
       * @description Status of the custom component.
       */
      status: string;
      /**
       * Version
       * @description Version of the custom component.
       */
      version: string;
    };
    /** CustomComponentLog */
    CustomComponentLog: {
      /**
       * Level
       * @description Log level, for example error or warning.
       */
      level: string;
      /**
       * Log entry ID
       * Format: uuid
       * @description Unique identifier of the log entry.
       */
      log_entry_id: string;
      /**
       * Message
       * @description Log message.
       */
      msg: string;
    };
    /** DCDocumentCount */
    DCDocumentCount: {
      /**
       * Total Documents
       * @description The total number of documents created for this pipeline.
       */
      count: number;
    };
    /** Dataset */
    Dataset: {
      /**
       * File Names
       * @description List of file names associated with the dataset
       */
      file_names: string[];
      /**
       * Dataset Name
       * @description Name of the dataset
       */
      name: string;
    };
    /** DatasetPagination */
    DatasetPagination: {
      /**
       * Dataset Items
       * @description List of datasets in the current page
       */
      data: components['schemas']['Dataset'][];
      /**
       * Total Count
       * @description Total number of datasets available
       */
      total: number;
    };
    /** DebugTunnelDeviceLoginCredentials */
    DebugTunnelDeviceLoginCredentials: {
      /**
       * Device login code
       * @description Code to login to the debug tunnel device.
       */
      code: string;
      /**
       * Device login URL
       * @description URL to login to the debug tunnel device.
       */
      url: string;
      /**
       * VSCode redirect URL
       * @description URL to redirect to VSCode.
       */
      vscode_url: string;
    } & {
      [key: string]: unknown;
    };
    /** DeepsetCloudAnswer */
    DeepsetCloudAnswer: {
      /** Answer */
      answer: string;
      /**
       * Context
       * @description Context of the answer.
       */
      context?:
        | string
        | {
            [key: string]: unknown;
          }
        | unknown[]
        | null;
      /**
       * Document ID
       * @description ID of the document.
       */
      document_id?: string | null;
      /**
       * Document IDs
       * @description IDs of the document.
       */
      document_ids?: string[] | null;
      /**
       * File Reference Object (deprecated, use `files` instead)
       * @description Object containing the `file_id` and `name` of a file. This is used to associate a document with a file.
       */
      file?: {
        [key: string]: unknown;
      } | null;
      /**
       * File Reference Objects
       * @description List of objects containing the `file_id` and `name` of a file. This is used to associate an answer with its source files.
       */
      files?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Metadata of file
       * @description The metadata of this document.
       */
      meta?: {
        [key: string]: unknown;
      } | null;
      /**
       * Offsets in Context
       * @description Offsets of the answer in the context.
       */
      offsets_in_context?:
        | components['schemas']['DeepsetCloudSpan'][]
        | components['schemas']['DeepsetCloudTableCell'][]
        | null;
      /**
       * Offsets in Document
       * @description Offsets of the answer in the document.
       */
      offsets_in_document?:
        | components['schemas']['DeepsetCloudSpan'][]
        | components['schemas']['DeepsetCloudTableCell'][]
        | null;
      /**
       * Prompt
       * @description The prompt that was used to generate the result.
       */
      prompt?: string | null;
      /**
       * Result ID
       * Format: uuid
       * @description Unique identifier of the result.
       */
      result_id?: string;
      /**
       * Score
       * @description Score of the answer.
       */
      score?: number | null;
      /**
       * Answer Type
       * @description Type of the answer.
       * @enum {string}
       */
      type: DeepsetCloudAnswerType;
    };
    /** DeepsetCloudDocument */
    DeepsetCloudDocument: {
      /**
       * Content
       * @description Content of the document.
       */
      content?:
        | string
        | {
            [key: string]: unknown;
          }
        | unknown[]
        | null;
      /**
       * Embedding
       * @description Embedding of the document.
       */
      embedding?: number[] | null;
      /**
       * File Reference Object (deprecated, use `files` instead)
       * @description Object containing the `file_id` and `name` of a file. This is used to associate a document with a file.
       */
      file?: {
        [key: string]: unknown;
      } | null;
      /**
       * Document ID
       * @description ID of the document.
       */
      id: string;
      /**
       * Metadata of file
       * @description The metadata of this document.
       */
      meta: {
        [key: string]: unknown;
      };
      /**
       * Result ID
       * @description Unique identifier of the result.
       */
      result_id?: string | null;
      /**
       * Score
       * @description Shows the relevance score of the prediction.
       */
      score?: number | null;
    };
    /** DeepsetCloudQueryResponse */
    DeepsetCloudQueryResponse: {
      /** Debug */
      _debug?: {
        [key: string]: unknown;
      } | null;
      /**
       * Answers
       * @description List of deepset answers.
       * @default []
       */
      answers: components['schemas']['DeepsetCloudAnswer'][];
      /**
       * Documents
       * @description List of deepset documents.
       * @default []
       */
      documents: components['schemas']['DeepsetCloudDocument'][];
      /**
       * Prompts
       * @description The prompts used in the query. This is only returned if the `view_prompts` flag is set to `true`.
       */
      prompts?: {
        [key: string]: string;
      } | null;
      /**
       * Query
       * @description The search query.
       */
      query: string;
      /**
       * Query ID
       * Format: uuid
       * @description Unique identifier of the search query.
       */
      query_id?: string;
    };
    /**
     * DeepsetCloudSchema
     * @description Autogenerated schema from the haystack-integration-service
     *
     *     This includes the components, inputs, outputs, connections, max_loops_allowed, and metadata
     *     and all available components and types (e.g. Document, Text, Image, etc.)
     */
    DeepsetCloudSchema: {
      /** @description Definitions of the schema */
      definitions: components['schemas']['SchemaDefinitions'];
      /**
       * Properties
       * @description Properties of the schema
       */
      properties: {
        [key: string]: unknown;
      };
      /**
       * Required
       * @description Required properties of the schema
       */
      required: string[];
      /**
       * Type
       * @description Type of the schema
       * @default object
       */
      type: string;
    };
    /** DeepsetCloudSpan */
    DeepsetCloudSpan: {
      /**
       * End
       * @description End of span.
       */
      end: number;
      /**
       * Start
       * @description Start of span.
       */
      start: number;
    };
    /** DeepsetCloudTableCell */
    DeepsetCloudTableCell: {
      /**
       * Column
       * @description Column of the answer.
       */
      col: number;
      /**
       * Row
       * @description Row of the answer.
       */
      row: number;
    };
    /**
     * DeepsetCloudVersion
     * @enum {string}
     */
    DeepsetCloudVersion: DeepsetCloudVersion;
    /** EmptyFilters */
    EmptyFilters: Record<string, never>;
    /** EntityRole */
    EntityRole: {
      /**
       * Workspace Name
       * @description Name of the workspace.
       */
      name: string;
      /**
       * User Role
       * @description Role of the user. This can be a custom role or one of the default roles.
       */
      role: components['schemas']['Roles'] | string;
      /**
       * Role ID
       * @description Unique identifier of the role.
       */
      role_id: string | null;
    };
    /** ExceptionTraceLog */
    ExceptionTraceLog: {
      /**
       * File Name
       * @description The name of the file where the exception occurred.
       */
      filename: string;
      /**
       * Line Number
       * @description The line number where the exception occurred.
       */
      line_number: number;
      /**
       * Name
       * @description The name of the module in which the exception happened.
       */
      name: string;
    };
    /** ExternalFacingDocumentStoreCredentials */
    ExternalFacingDocumentStoreCredentials: {
      /**
       * AWS Domain ARN
       * @description The AWS domain ARN of your OpenSearch cluster. Follow [our documentation](https://docs.cloud.deepset.ai/docs/connect-your-own-file-storage) to find your ARN.
       */
      aws_domain_arn: string;
      /**
       * Credentials ID
       * Format: uuid
       * @description Unique ID of the credentials.
       */
      credentials_id: string;
    };
    /** ExternalS3Credentials */
    ExternalS3Credentials: {
      /**
       * AWS Endpoint URL
       * @description The AWS endpoint URL of your S3 bucket.
       */
      aws_endpoint_url?: string | null;
      /**
       * S3 Bucket Name
       * @description The name of your S3 bucket.
       */
      bucket_name: string;
      /**
       * Credentials ID
       * Format: uuid
       * @description Unique ID of the credentials.
       */
      credentials_id: string;
    };
    /** Feedback */
    Feedback: {
      /** Bookmarked */
      bookmarked?: boolean | null;
      /** Comment */
      comment?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      created_by: components['schemas']['UserIdName'];
      /**
       * Feedback Id
       * Format: uuid
       */
      feedback_id: string;
      /**
       * Organization Id
       * Format: uuid
       */
      organization_id: string;
      /**
       * Pipeline Id
       * Format: uuid
       */
      pipeline_id: string;
      /**
       * Result Id
       * Format: uuid
       */
      result_id: string;
      /** Score */
      score?: string | null;
      search_history: components['schemas']['SearchHistoryResultData'];
      /** Tags */
      tags: components['schemas']['FeedbackTag'][];
      /**
       * Workspace Id
       * Format: uuid
       */
      workspace_id: string;
    };
    /** FeedbackSearchQuery */
    FeedbackSearchQuery: {
      /**
       * Created At
       * Format: date-time
       * @description Specifies when the search query was run.
       */
      created_at: string;
      /**
       * Duration
       * @description The number of seconds the pipeline took to find the answer.
       */
      duration: number;
      /**
       * Search Filters
       * @description Shows which metadata filters were used for the search query.
       */
      filters?: {
        [key: string]: unknown;
      } | null;
      /**
       * Query
       * @description The search query.
       */
      query: string;
    };
    /**
     * FeedbackSelectResult
     * @description Feedback Select Description
     */
    FeedbackSelectResult: {
      [key: string]: unknown;
    };
    /** FeedbackStats */
    FeedbackStats: {
      /**
       * Accuracy
       * @description The accuracy of the pipeline. We compute the accuracy by dividing the total number of queries with positive feedback by the total number of queries with any feedback. Searches without any feedback are therefore not taken into account.
       */
      accuracy: number | null;
      /**
       * Feedback Count
       * @description The amount of feedback.
       */
      feedback_count: number;
      /**
       * Negative feedback count
       * @description The total number of negative feedback entries.
       */
      negative_feedback_count: number;
      /**
       * Neutral feedback count
       * @description The total number of neutral feedback entries.
       */
      neutral_feedback_count: number;
      /**
       * Positive feedback count
       * @description The total number of positive feedback entries.
       */
      positive_feedback_count: number;
      /**
       * User Count
       * @description The number of users who have given feedback.
       */
      user_count: number;
    };
    /** FeedbackTag */
    FeedbackTag: {
      /**
       * Created By User Id
       * Format: uuid
       */
      created_by_user_id: string;
      /** Name */
      name: string;
      /**
       * Organization Id
       * Format: uuid
       */
      organization_id: string;
      /**
       * Pipeline Id
       * Format: uuid
       */
      pipeline_id: string;
      /**
       * Tag Id
       * Format: uuid
       */
      tag_id: string;
      /**
       * Workspace Id
       * Format: uuid
       */
      workspace_id: string;
    };
    /** FetchDocumentsParams */
    FetchDocumentsParams: {
      /**
       * Haystack Filters
       * @description Filters you can use to narrow down the search. For more information, see [filtering logic](https://docs.cloud.deepset.ai/docs/filtering-logic).
       */
      filters?:
        | components['schemas']['LogicalCondition']
        | components['schemas']['ComparisonCondition']
        | components['schemas']['EmptyFilters']
        | null;
      /**
       * Limit
       * @description Limits the number of documents returned.
       */
      limit?: number | null;
      /**
       * Return Embedding
       * @description Returns vector representations of the documents.
       */
      return_embedding?: boolean | null;
      /**
       * Use Prefiltering
       * @description Specifies if documents should be prefiltered in the document store instead of within the retriever. DEPRECATED: This parameter will be removed in a future version. Use efficient_filtering parameter instead.
       */
      use_prefiltering?: boolean | null;
    };
    /** File */
    File: {
      /**
       * Number of characters
       * @description The total number of characters in this file.
       */
      characters: number;
      /**
       * File Creation
       * Format: date-time
       * @description Datetime object, specifies when the file was created.
       */
      created_at: string;
      /**
       * File ID
       * Format: uuid
       * @description Unique identifier of a file.
       */
      file_id: string;
      /**
       * Languages
       * @description List of languages in that file.
       */
      languages?: string[] | null;
      /**
       * Metadata of file
       * @description Metadata of a file.
       */
      meta: {
        [key: string]: unknown;
      };
      /**
       * File name
       * @description Name of the file.
       */
      name: string;
      /**
       * File size
       * @description Size of the file in bytes.
       */
      size: number;
      /**
       * File URL
       * @description The URL of the file.
       */
      url: string;
    };
    /**
     * File ID
     * Format: uuid
     */
    FileId: string;
    /** FileIngestionStatus */
    FileIngestionStatus: {
      /**
       * Failed files
       * @description The number of files that failed to be ingested.
       * @default 0
       */
      failed_files: number;
      /**
       * Finished files
       * @description The number of files that were successfully ingested.
       * @default 0
       */
      finished_files: number;
    };
    /**
     * FileIngestionStatusEnum
     * @enum {string}
     */
    FileIngestionStatusEnum: FileIngestionStatusEnum;
    /**
     * FileIngestionStatusReasonEnum
     * @enum {string}
     */
    FileIngestionStatusReasonEnum: FileIngestionStatusReasonEnum;
    /** Metadata of file */
    FileMetadata: {
      [key: string]: unknown;
    };
    /** FileNames */
    FileNames: {
      /**
       * File names
       * @description The names of the files to delete.
       */
      names: string[];
    };
    /** FilePagination */
    FilePagination: {
      /** Data */
      data: components['schemas']['File'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /**
     * FileStatus
     * @description Enum for the status of a file in the document store.
     * @enum {string}
     */
    FileStatus: FileStatus;
    /** FileUpdateError */
    FileUpdateError: {
      /**
       * Error message
       * @description The error message.
       */
      error_message: string;
      /**
       * Error type
       * @description The type of error that occurred.
       */
      error_type: string;
      /**
       * File ID
       * Format: uuid
       * @description Unique identifier of a file.
       */
      file_id: string;
    };
    /**
     * FileWriteModeEnum
     * @enum {string}
     */
    FileWriteModeEnum: FileWriteModeEnum;
    /** GenerateIntegratedYamlData */
    GenerateIntegratedYamlData: {
      /**
       * Original YAML
       * @description The original YAML which will be udpated with the changes from update data.
       */
      original: string;
      /**
       * Updated data
       * @description A dictionary containing updated data which will be merged into the original YAML.
       */
      updated: {
        [key: string]: unknown;
      };
    };
    /** HTTPValidationError */
    HTTPValidationError: {
      /** Detail */
      detail?: components['schemas']['ValidationError'][];
    };
    /** HaystackComponentInitParams */
    HaystackComponentInitParams: {
      /**
       * Component Type
       * @description Type of the component.
       */
      component_type: string;
      /**
       * Init Params
       * @description Component init params as key-value pairs of param name and value.
       */
      init_params: {
        [key: string]: unknown;
      };
    };
    /** HaystackComponentInputOutputSchema */
    HaystackComponentInputOutputSchema: {
      /**
       * Input schema of the component
       * @description Input schema of the component
       */
      input: {
        [key: string]: unknown;
      };
      /**
       * Haystack Component Input Output Schema
       * @description Schema for all available haystack components.
       */
      name: string;
      /**
       * Output schema of the component
       * @description Output schema of the component
       */
      output: {
        [key: string]: unknown;
      };
    };
    /** HaystackComponentSchema */
    HaystackComponentSchema: {
      /**
       * Haystack Component Schema
       * @description Schema for all available haystack components.
       */
      component_schema: components['schemas']['DeepsetCloudSchema'];
    };
    /**
     * LogOrigin
     * @enum {string}
     */
    LogOrigin: LogOrigin;
    /** LogicalCondition */
    LogicalCondition: {
      /**
       * Conditions
       * @description The conditions you want to use for logical conditions.
       */
      conditions: (
        | components['schemas']['ComparisonCondition']
        | components['schemas']['LogicalCondition']
      )[];
      /**
       * Logical Condition Operator
       * @description The operator you want to use for logical conditions.
       */
      operator: components['schemas']['LogicalOperator'];
    };
    /**
     * LogicalOperator
     * @enum {string}
     */
    LogicalOperator: LogicalOperator;
    /** ModelMeta */
    ModelMeta: {
      /**
       * Model ID
       * @description The unique identifier of the model available for the node.
       */
      id: string;
      /**
       * Pipeline Tag
       * @description The tag of the Hugging Face model.
       */
      pipeline_tag?: string | null;
      /**
       * Private
       * @description Whether the model is private or public.
       */
      private: boolean;
      /**
       * Provider
       * @description The provider of the model.
       */
      provider: string;
    };
    /**
     * ModelProvider
     * @enum {string}
     */
    ModelProvider: ModelProvider;
    /** Model Registry Token */
    ModelRegistryToken: {
      /**
       * Invalid Token
       * @description Indicates whether the token is invalid.
       */
      invalid: boolean;
      /**
       * Model registry token ID
       * Format: uuid
       * @description Unique identifier of the model registry token.
       */
      model_registry_token_id: string;
      /**
       * Provider
       * @description Model provider, for example Hugging Face.
       */
      provider: components['schemas']['ModelProvider'];
      /**
       * Provider Domain
       * @description Model provider domain, for example huggingface.co.
       */
      provider_domain: string;
    };
    /** NewOpenSearchVPCCredentials */
    NewOpenSearchVPCCredentials: {
      /**
       * AWS Domain ARN
       * @description The AWS domain ARN of your OpenSearch cluster. Follow [our documentation](https://docs.cloud.deepset.ai/docs/connect-your-own-file-storage) to find your ARN.
       */
      aws_domain_arn: string;
      /**
       * Password
       * @description The password to your OpenSearch cluster.
       */
      password: string;
      /**
       * OpenSearch Port
       * @description The port of your OpenSearch cluster.
       * @default 443
       */
      port: number;
      /**
       * Username
       * @description Your OpenSearch cluster username.
       */
      username: string;
    };
    /** NewS3Credentials */
    NewS3Credentials: {
      assume_role: components['schemas']['AWSAssumeRoleCredentials'];
      /**
       * AWS Endpoint URL
       * @description The AWS endpoint URL of your S3 bucket.
       */
      aws_endpoint_url?: string | null;
      /**
       * S3 Bucket Name
       * @description The name of your S3 bucket.
       */
      bucket_name: string;
    };
    /** NewWorkspace */
    NewWorkspace: {
      document_store_credentials?:
        | components['schemas']['WorkspaceDocumentStoreCredentials']
        | null;
      file_store_credentials?: components['schemas']['WorkspaceFileStoreCredentials'] | null;
      /**
       * Workspace name
       * @description The name of the workspace. It must be longer than 3 characters.
       */
      name: string;
    };
    /** OrganizationFormatted */
    OrganizationFormatted: {
      /**
       * Max Workspaces
       * @description Maximum number of workspaces a user can access.
       */
      max_workspaces: number;
      /**
       * Organization name
       * @description Unique name of a deepset organization.
       */
      name: string;
      /**
       * Organization ID
       * Format: uuid
       * @description Unique identifier of an organization.
       */
      organization_id: string;
      /**
       * Organization Type
       * @description Type of the organization.
       */
      organization_type: components['schemas']['OrganizationType'];
      /**
       * Pricing plan
       * @description Pricing plan of an organization, between 0 and 3.
       */
      pricing_plan?: number | null;
      /**
       * User Role
       * @description Role of the user. This can be a custom role or one of the default roles.
       */
      role: string;
      /**
       * User Workspaces
       * @description Workspaces the user can access.
       */
      workspaces: components['schemas']['EntityRole'][];
    };
    /** OrganizationName */
    OrganizationName: {
      /**
       * Organization name
       * @description Unique name of a deepset organization.
       */
      name: string;
    };
    /**
     * OrganizationType
     * @enum {string}
     */
    OrganizationType: OrganizationType;
    /** PaginatedCustomComponents */
    PaginatedCustomComponents: {
      /**
       * Matching custom components in the request page that meets your filter criteria.
       * @description A list of matching custom components.
       */
      data: components['schemas']['CustomComponent'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PaginatedFeedback */
    PaginatedFeedback: {
      /**
       * Matching jobs in the request page matching your filter criteria
       * @description A list of matching jobs.
       */
      data: (components['schemas']['Feedback'] | components['schemas']['FeedbackSelectResult'])[];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PaginatedPipelineTemplates */
    PaginatedPipelineTemplates: {
      /**
       * Paginated Pipeline Templates
       * @description A list of matching pipeline templates.
       */
      data: (
        | components['schemas']['PipelineTemplate']
        | components['schemas']['PipelineTemplateSelectResult']
      )[];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PaginatedPromptTemplates */
    PaginatedPromptTemplates: {
      /**
       * Matching prompt templates in the request page matching your filter criteria
       * @description A list of matching prompt templates.
       */
      data: (
        | components['schemas']['PromptTemplate']
        | components['schemas']['PromptTemplateSelectResult']
      )[];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PaginatedPublicPromptTemplates */
    PaginatedPublicPromptTemplates: {
      /**
       * Matching prompt templates in the request page matching your filter criteria
       * @description A list of matching prompt templates.
       */
      data: (
        | components['schemas']['PublicPromptTemplate']
        | components['schemas']['PublicPromptTemplateSelectResult']
      )[];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PaginatedSearchSessions */
    PaginatedSearchSessions: {
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Search Sessions
       * @description A list of all search sessions with their details.
       */
      search_sessions: components['schemas']['SearchSessionGetResponse'][];
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PaginatedSession */
    PaginatedSession: {
      /** Data */
      data: components['schemas']['Session'][];
      /**
       * Upload Session Has More
       * @description Whether the session has more files.
       */
      has_more: boolean;
      /**
       * Upload Session Total
       * @description The total number of files in the session.
       */
      total: number;
    };
    /** PaginatedSessionFile */
    PaginatedSessionFile: {
      /** Data */
      data: components['schemas']['SessionFile'][];
      /**
       * Upload Session Has More
       * @description Whether the session has more files.
       */
      has_more: boolean;
      /**
       * Upload Session Total
       * @description The total number of files in the session.
       */
      total: number;
    };
    /** PaginatedSharedPrototypes */
    PaginatedSharedPrototypes: {
      /**
       * Matching shared prototypes in the request page matching your filter criteria
       * @description A list of matching shared prototypes.
       */
      data: components['schemas']['SharedPrototype'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PaginatedTags */
    PaginatedTags: {
      /**
       * Matching tags in the request page matching your filter criteria
       * @description A list of matching tags.
       */
      data: components['schemas']['FeedbackTag'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PatchSharedPrototype */
    PatchSharedPrototype: {
      /**
       * Brand Color
       * @description Specify a hexadecimal color code to represent the branding of the shared prototype.
       */
      brand_color?: string | null;
      /**
       * Brand Logo
       * @description Provide a base64 encoded string of the brand logo image.
       */
      brand_logo?: string | null;
      /**
       * Description
       * @description Explain how you expect the users to use this pipeline. Users who visit the shared prototype will see this text. For more information on how to set the right expectations regarding your pipeline, see [Guidelines for Onboarding Your Users](https://docs.cloud.deepset.ai/docs/guidelines-for-onboarding-your-users).
       */
      description?: string | null;
      /**
       * Show files
       * @description Select `True` if you want your users to be able to view the pipeline files.
       * @default false
       */
      show_files: boolean;
      /**
       * Show metadata filters
       * @description Select `True` if you want your users to be able to filter the documents by metadata.
       * @default false
       */
      show_metadata_filters: boolean;
    };
    /** Permission */
    Permission: {
      action: components['schemas']['Action'];
      asset: components['schemas']['Assets'];
    };
    /** Pipeline Object */
    Pipeline: {
      /**
       * Pipeline Creation
       * Format: date-time
       * @description Datetime object, specifies when the pipeline was created.
       */
      created_at: string;
      /**
       * Created by
       * @description The user who created the pipeline.
       */
      created_by?: components['schemas']['UserIdName'] | null;
      /**
       * deepset Version
       * @description The version of deepset the pipeline was created with.
       */
      deepset_cloud_version: components['schemas']['DeepsetCloudVersion'];
      /**
       * Pipeline Deleted
       * @description Soft deletion of pipelines.
       * @default false
       */
      deleted: boolean;
      /**
       * Desired pipeline status
       * @description Desired status of a pipeline. Possible values are: 'DEPLOYED' or 'UNDEPLOYED'.
       */
      desired_status: string;
      /**
       * Pipeline Idle Timeout
       * @description The time in seconds after which the pipeline is put on standby if it's not used.
       */
      idle_timeout_in_seconds: number | null;
      /**
       * Pipeline is default
       * @description Pipeline is set to default.
       */
      is_default: boolean;
      /**
       * Last deployment time
       * @description Datetime object, specifies when the pipeline was last deployed.
       */
      last_deployed_at?: string | null;
      /**
       * Last update time
       * @description Datetime object, specifies when the pipeline was edited.
       */
      last_edited_at?: string | null;
      /**
       * Last edited by user
       * @description The user who last edited the pipeline.
       */
      last_edited_by?: components['schemas']['UserIdName'] | null;
      /**
       * Pipeline Name
       * @description Name of the pipeline.
       */
      name: string;
      /**
       * Pipeline output type
       * @description Specifies the type of output the pipeline returns. Possible values are: 'generative', 'extractive', 'chat', or 'document'.
       */
      output_type: string;
      /**
       * Pipeline ID
       * Format: uuid
       * @description Unique identifier of a pipeline.
       */
      pipeline_id: string;
      /**
       * Pipeline Service Level
       * @description Service level determines the infrastructure and availability requirements for a pipeline. Pipelines at 'PRODUCTION' service level have an extended active period before they enter the standby mode and offer enhanced scalability. 'DEVELOPMENT' pipelines enter standby after 12 hours and lack scalability in case of any infrastructure issues.
       */
      service_level: components['schemas']['PipelineServiceLevelWithDraftEnum'];
      /**
       * Query pipeline status (deprecated).
       * @description The current status of a pipeline.
       */
      status: string;
      /**
       * Pipeline supports prompt
       * @description Indicates whether the pipeline supports prompts.
       */
      supports_prompt: boolean;
    };
    /** PipelineExceptionLog */
    PipelineExceptionLog: {
      /**
       * Trace
       * @description The traceback of the exception.
       */
      trace?: components['schemas']['ExceptionTraceLog'][];
      /**
       * Type
       * @description The type of the exception.
       */
      type: string;
      /**
       * Value
       * @description The value of the exception.
       */
      value: string;
    };
    /** PipelineFeedbackFile */
    PipelineFeedbackFile: {
      /**
       * File ID
       * @description Unique identifier of a file.
       */
      id?: string | null;
      /**
       * File name
       * @description Name of the file.
       */
      name?: string | null;
    };
    /** PipelineFieldSearchResult */
    PipelineFieldSearchResult: {
      /**
       * Field Search Results
       * @description A list of fields that you searched for.
       */
      data: (string | number | boolean)[];
      /**
       * Has More
       * @description Indicates whether the paginated result has more results.
       */
      has_more: boolean;
      /**
       * Total Number of Results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PipelineIndex */
    PipelineIndex: {
      /**
       * Pipeline Index Config YAML
       * @description Config YAML of the pipeline index.
       */
      config_yaml: string | null;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the pipeline index was created.
       */
      created_at: string;
      /**
       * Created By User ID
       * @description ID of the user who created the pipeline index.
       */
      created_by: components['schemas']['UserIdName'] | null;
      /**
       * Pipeline Index Deployed At
       * @description Timestamp when the pipeline index was deployed.
       */
      deployed_at: string | null;
      /**
       * Pipeline Index Description
       * @description Description of the pipeline index.
       */
      description?: string | null;
      /**
       * Pipeline Index Desired Status
       * @description The desired status of the pipeline index.
       */
      desired_status: components['schemas']['PipelineIndexDesiredStatus'];
      /**
       * Last Edited At
       * @description Timestamp when the pipeline index was last edited.
       */
      last_edited_at: string | null;
      /**
       * Last Edited By User ID
       * @description ID of the user who last edited the pipeline index.
       */
      last_edited_by: components['schemas']['UserIdName'] | null;
      /**
       * Maximum Index Replica Count
       * @description Maximum number of replicas allowed for the pipeline index.
       */
      max_index_replica_count: number;
      /**
       * Pipeline Index Name
       * @description Name of the pipeline index.
       */
      name: string;
      /**
       * Pipeline Index ID
       * Format: uuid
       * @description Unique identifier of the pipeline index.
       */
      pipeline_index_id: string;
      /**
       * Pipeline Index Settings
       * @description Settings for the pipeline index.
       * @default {}
       */
      settings: {
        [key: string]: unknown;
      };
      /**
       * Pipeline Index Indexing
       * @description Indexing status of the pipeline index.
       */
      status: components['schemas']['PipelineIndexingStatusDetail'];
      /**
       * Updated At
       * @description Timestamp when the pipeline index was last updated.
       */
      updated_at: string | null;
      /**
       * Pipeline Index Workspace ID
       * Format: uuid
       * @description Workspace ID of the pipeline index.
       */
      workspace_id: string;
    };
    /**
     * PipelineIndexDesiredStatus
     * @enum {string}
     */
    PipelineIndexDesiredStatus: PipelineIndexDesiredStatus;
    /** PipelineIndexMetadataProperty */
    PipelineIndexMetadataProperty: {
      /**
       * Data type of the the metadata field.
       * @description The associated data type of the metadata field such as 'keyword', 'long', 'float', or 'date'.
       */
      type: string;
    };
    /** PipelineIndexMetadataPropertyWithNesting */
    PipelineIndexMetadataPropertyWithNesting:
      | components['schemas']['PipelineIndexMetadataProperty']
      | {
          [key: string]: components['schemas']['PipelineIndexMetadataPropertyWithNesting'];
        };
    /** Pipeline Index Pagination */
    PipelineIndexPagination: {
      /**
       * Pipeline Index List
       * @description A list of pipeline indexes.
       */
      data: components['schemas']['PipelineIndex'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PipelineIndexingStatusDetail */
    PipelineIndexingStatusDetail: {
      /**
       * Failed Files
       * @description Files that failed to be indexed.
       */
      failed_file_count: number;
      /**
       * Indexed Files
       * @description Files that were successfully indexed.
       */
      indexed_file_count: number;
      /**
       * Indexed Files with No Documents.
       * @description The number of files that were indexed but didn't create documents.
       */
      indexed_no_documents_file_count: number;
      /**
       * Pending Files
       * @description The number of files pending to be indexed.
       */
      pending_file_count: number;
      /**
       * Total Files
       * @description The total number of files assigned to a pipeline.
       */
      total_file_count: number;
    };
    /** PipelineIssue */
    PipelineIssue: {
      /**
       * Match
       * @description A search term used to match against pipeline logs to identify runtime issues.
       */
      match: string;
      /**
       * Message
       * @description The details of a pipeline runtime issue.
       */
      message: string;
      /**
       * Title
       * @description The title of a pipeline runtime issue.
       */
      title: string;
    };
    /** PipelineIssues */
    PipelineIssues: {
      /** Data */
      data: components['schemas']['PipelineIssue'][];
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PipelineLog */
    PipelineLog: {
      /**
       * Exceptions
       * @description Describes the exception that occurred.
       */
      exceptions?: components['schemas']['PipelineExceptionLog'][] | null;
      /**
       * Extra Fields
       * @description Extra fields that were logged.
       */
      extra_fields?: {
        [key: string]: unknown;
      } | null;
      /**
       * Level
       * @description The log level.
       */
      level: string;
      /**
       * Log ID
       * @description The ID of the log.
       */
      log_id: string;
      /**
       * Logged At
       * Format: date-time
       * @description The time the log message was created.
       */
      logged_at: string;
      /**
       * Message
       * @description The log message.
       */
      message: string;
      /**
       * Log Origin
       * @description The origin of the log.
       */
      origin: components['schemas']['LogOrigin'];
    };
    /** PipelineLogPagination */
    PipelineLogPagination: {
      /** Data */
      data: components['schemas']['PipelineLog'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PipelineMetadataAggregation */
    PipelineMetadataAggregation: {
      /**
       * Maximum Value of the Metadata Field
       * @description The maximum value of the metadata field.
       */
      max: number | string | null;
      /**
       * Minimum Value of the Metadata Field
       * @description The minimum value of the metadata field.
       */
      min: number | string | null;
    };
    /** PipelineName */
    PipelineName: {
      /**
       * Pipeline Name
       * @description Name of the pipeline.
       */
      name: string;
    };
    /** PipelinePagination */
    PipelinePagination: {
      /**
       * Pipeline List
       * @description List of pipelines.
       */
      data: components['schemas']['Pipeline'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** PipelinePrompt */
    PipelinePrompt: {
      /**
       * Prompt text
       * @description The prompt text used in the pipeline.
       */
      text: string;
    };
    /** PipelinePrompts */
    PipelinePrompts: {
      /**
       * Prompts of the pipeline
       * @description A dictionary of prompts having the prompt node name as the key and the prompt text and template_name as value.
       */
      prompts: {
        [key: string]: {
          [key: string]: string;
        };
      };
    };
    /** PipelineQuery */
    PipelineQuery: {
      /**
       * Debug Flag
       * @description Shows debug output for the pipeline (for example, prompt).
       * @default false
       */
      debug: boolean | null;
      /**
       * Files
       * @description A list of files in the workspace.
       */
      files?: components['schemas']['FileId'][] | null;
      /**
       * Haystack Filters
       * @description Filters you can use to narrow down the search. For more information, see [filtering logic](https://docs.cloud.deepset.ai/docs/filtering-logic).
       */
      filters?:
        | components['schemas']['LogicalCondition']
        | components['schemas']['ComparisonCondition']
        | components['schemas']['EmptyFilters']
        | null;
      /**
       * Pipeline Parameters
       * @description Parameters you can use to customize the pipeline. For details, see [Haystack documentation for the pipeline `run()` method](https://docs.haystack.deepset.ai/reference/pipeline-api). These filters can be used to pass additional parameters to the pipeline.(Haystack is the underlying technology for deepset.)
       */
      params?: {
        [key: string]: unknown;
      } | null;
      /**
       * Queries
       * @description A list of queries you want to run through the pipeline.
       */
      queries: string[];
      /**
       * Search Session ID
       * @description The ID of the search session you want to use for chat.
       */
      search_session_id?: string | null;
      /**
       * View prompts
       * @description Adds the runtime prompts of all nodes to the response. (Pipeline runs in debug mode.)
       * @default false
       */
      view_prompts: boolean;
    };
    /**
     * PipelineServiceLevelEnum
     * @enum {string}
     */
    PipelineServiceLevelEnum: PipelineServiceLevelEnum;
    /**
     * PipelineServiceLevelWithDraftEnum
     * @enum {string}
     */
    PipelineServiceLevelWithDraftEnum: PipelineServiceLevelWithDraftEnum;
    /** PipelineStatistics */
    PipelineStatistics: {
      /**
       * Accuracy of Answers
       * @description The accuracy of answers is calculated by dividing the total number of positive feedback messages by the total number of all feedback messages. Pipelines with feedback on multiple responses are counted only once.
       */
      accuracy_of_answers?: number | null;
      /**
       * Average Feedback per Query
       * @description The average number of feedback messages per query.
       * @default 0
       */
      avg_feedback_per_query: number;
      /**
       * Correct Answers
       * @description The number of answers marked as correct.
       * @default 0
       */
      correct_answers: number;
      /**
       * Experiments Created
       * @description The total number of experiments created for this pipeline.
       * @default 0
       */
      experiments_created: number;
      /**
       * Indexed Files
       * @description The total number of files indexed for this pipeline.
       * @default 0
       */
      indexed_files: number;
      /**
       * Latency
       * @description The average latency of the queries in seconds.
       * @default 0
       */
      latency: number;
      /**
       * Manual Feedback Input
       * @description The total number of manual feedback inputs provided by users for this pipeline.
       * @default 0
       */
      manual_feedback_input: number;
      /**
       * Total Documents
       * @description The total number of documents created for this pipeline.
       * @default 0
       */
      total_documents: number;
      /**
       * Total Queries
       * @description The total number of queries for this pipeline.
       * @default 0
       */
      total_queries: number;
      /**
       * Feedback Provided by Users
       * @description The total number of unique feedback messages the users provided for the results of this pipeline.
       * @default 0
       */
      users_provided_feedback: number;
      /**
       * Wrong Answers
       * @description The number of answers marked as wrong.
       * @default 0
       */
      wrong_answers: number;
      /**
       * Wrong Answers with Correct Document
       * @description The number of answers marked as wrong by the user while the document was marked as correct.
       * @default 0
       */
      wrong_answers_with_correct_document: number;
    };
    /**
     * PipelineStatus
     * @enum {string}
     */
    PipelineStatus: PipelineStatus;
    /** PipelineTemplate */
    PipelineTemplate: {
      /**
       * Pipeline Template Author
       * @description Author of the pipeline template.
       */
      author: string;
      /**
       * Available to all organization types
       * @description Whether the pipeline template is available to all organization types in deepset.
       * @default false
       */
      available_to_all_organization_types: boolean;
      /**
       * Best For
       * @description The best use case for the pipeline template.
       */
      best_for: string[];
      /**
       * deepset Version
       * @description The version of deepset this pipeline template is compatible with.
       */
      deepset_cloud_version: components['schemas']['DeepsetCloudVersion'];
      /**
       * Pipeline Template Description
       * @description Description of the pipeline template.
       */
      description: string;
      /**
       * Expected Output
       * @description The output of this pipeline template.
       */
      expected_output: string[];
      /**
       * Indexing YAML
       * @description The Haystack pipeline YAML configuration for indexing provided by the pipeline template.
       */
      indexing_yaml?: string | null;
      /**
       * Pipeline Template Name
       * @description Name of the pipeline template.
       */
      name: string;
      /**
       * Name of the Pipeline
       * @description Initial name of a pipeline when created from this template.
       */
      pipeline_name: string;
      /**
       * Pipeline Template ID
       * Format: uuid
       * @description Unique identifier of the pipeline template.
       */
      pipeline_template_id: string;
      /**
       * Pipeline Type
       * @description The type of pipeline this template is for.
       */
      pipeline_type: components['schemas']['PipelineType'];
      /**
       * Potential Applications
       * @description Examples of real-life scenarios for this pipeline templates.
       */
      potential_applications: string[];
      /**
       * Query YAML
       * @description The Haystack pipeline YAML configuration for querying provided by the pipeline template.
       */
      query_yaml?: string | null;
      /**
       * Recommended Dataset
       * @description The type of data this pipeline template works best on.
       */
      recommended_dataset: string[];
      /**
       * Pipeline Template Tags
       * @description The tags assigned to the pipeline template.
       */
      tags: components['schemas']['Tag'][];
    };
    /**
     * PipelineTemplateSelectResult
     * @description The pipeline template fields you selected.
     */
    PipelineTemplateSelectResult: {
      [key: string]: unknown;
    };
    /**
     * PipelineType
     * @enum {string}
     */
    PipelineType: PipelineType;
    /** PipelineUpdateRequest */
    PipelineUpdateRequest: {
      /**
       * Pipeline Name
       * @description Name of the pipeline.
       */
      name?: string | null;
      /**
       * Pipeline Service Level
       * @description Service level determines the infrastructure and availability requirements for a pipeline. Pipelines at 'PRODUCTION' service level have an extended active period before they enter the standby mode and offer enhanced scalability. 'DEVELOPMENT' pipelines enter standby after 12 hours and lack scalability in case of any infrastructure issues.
       */
      service_level?: components['schemas']['PipelineServiceLevelEnum'] | null;
      /**
       * Query pipeline status (deprecated).
       * @description The current status of a pipeline.
       */
      status?: components['schemas']['PipelineStatus'] | null;
    };
    /** PipelineVisualizationMetadata */
    'PipelineVisualizationMetadata-Input': {
      /**
       * Components
       * @description Component names and their visualizations.
       */
      components: {
        [key: string]: components['schemas']['ComponentVisualizationMetadata'];
      };
    };
    /** PipelineVisualizationMetadata */
    'PipelineVisualizationMetadata-Output': {
      /**
       * Components
       * @description Component names and their visualizations.
       */
      components: {
        [key: string]: components['schemas']['ComponentVisualizationMetadata'];
      };
    };
    /** PipelineYAMLConfiguration */
    PipelineYAMLConfiguration: {
      /**
       * deepset Version
       * @description The version of deepset the pipeline was created with.
       */
      deepset_cloud_version: components['schemas']['DeepsetCloudVersion'];
      /**
       * Query YAML
       * @description The deepset pipeline YAML configuration for querying.
       */
      query_yaml: string | null;
    };
    /** PostSharedPrototype */
    PostSharedPrototype: {
      /**
       * Brand Color
       * @description Specify a hexadecimal color code to represent the branding of the shared prototype.
       */
      brand_color?: string | null;
      /**
       * Brand Logo
       * @description Provide a base64 encoded string of the brand logo image.
       */
      brand_logo?: string | null;
      /**
       * Description
       * @description Explain how you expect the users to use this pipeline. Users who visit the shared prototype will see this text. For more information on how to set the right expectations regarding your pipeline, see [Guidelines for Onboarding Your Users](https://docs.cloud.deepset.ai/docs/guidelines-for-onboarding-your-users).
       */
      description?: string | null;
      /**
       * Expiration date
       * Format: date-time
       * @description The date after which the generated link will expire and become invalid. The expiration date must be within 60 days from the current date.
       */
      expiration_date: string;
      /**
       * Login required
       * @description Select whether users need to log in to access the shared prototype.
       * @default false
       */
      login_required: boolean;
      /**
       * Pipeline names
       * @description The names of the pipelines which you want to share.
       */
      pipeline_names: string[];
      /**
       * Show files
       * @description Select `True` if you want your users to be able to view the pipeline files.
       * @default false
       */
      show_files: boolean;
      /**
       * Show metadata filters
       * @description Select `True` if you want your users to be able to filter the documents by metadata.
       * @default false
       */
      show_metadata_filters: boolean;
    };
    /** PresignedPrefix */
    PresignedPrefix: {
      /**
       * Request fields
       * @description The fields to include in the request to the presigned URL. These fields are required in the body of each request.
       */
      fields: {
        [key: string]: string;
      };
      /**
       * Presigned URL
       * @description The presigned URL to upload the file to. This URL was generated using the AWS ShareObjectPresignedUrl feature. To learn more, see [AWS Documentation](https://docs.aws.amazon.com/AmazonS3/latest/userguide/ShareObjectPreSignedURL.html).
       */
      url: string;
    };
    /** PromptTemplate */
    PromptTemplate: {
      /**
       * Prompt Template Description
       * @description Description of the prompt template.
       */
      description: string;
      /**
       * Prompt Template Name
       * @description Name of the prompt template.
       */
      name: string;
      /**
       * Prompt Template ID
       * Format: uuid
       * @description Unique identifier of the prompt template.
       */
      prompt_template_id: string;
      /**
       * Prompt Template Tags
       * @description Tags assigned to the prompt template.
       */
      tags: components['schemas']['Tag'][];
      /**
       * Prompt Template Text
       * @description Text of the prompt.
       */
      text: string;
      /**
       * User
       * @description All user information.
       */
      user: components['schemas']['UserIdName'];
    };
    /** PromptTemplatePost */
    PromptTemplatePost: {
      /**
       * Prompt Template Description
       * @description Description of the prompt template.
       */
      description: string;
      /**
       * Prompt Template Name
       * @description Name of the prompt template.
       */
      name: string;
      /**
       * Prompt Template Tags
       * @description Tags assigned to the prompt template.
       */
      tags: string[];
      /**
       * Prompt Template Text
       * @description Text of the prompt.
       */
      text: string;
    };
    /** PromptTemplatePut */
    PromptTemplatePut: {
      /**
       * Prompt Template Description
       * @description Description of the prompt template.
       */
      description: string;
      /**
       * Prompt Template Name
       * @description Name of the prompt template.
       */
      name: string;
      /**
       * Prompt Template Tags
       * @description Tags assigned to the prompt template.
       */
      tags: string[];
      /**
       * Prompt Template Text
       * @description Text of the prompt.
       */
      text: string;
    };
    /**
     * PromptTemplateSelectResult
     * @description Result of a prompt template select operation.
     */
    PromptTemplateSelectResult: {
      [key: string]: unknown;
    };
    /** PublicPromptTemplate */
    PublicPromptTemplate: {
      /**
       * Prompt Template Description
       * @description Description of the prompt template.
       */
      description: string;
      /**
       * Prompt Template Meta
       * @description Metadata of the prompt template.
       */
      meta: {
        [key: string]: unknown;
      };
      /**
       * Prompt Template Name
       * @description Name of the prompt template.
       */
      name: string;
      /**
       * Prompt Template ID
       * Format: uuid
       * @description Unique identifier of the prompt template.
       */
      public_prompt_template_id: string;
      /**
       * Prompt Template Tags
       * @description Tags assigned to the prompt template.
       */
      tags: components['schemas']['Tag'][];
      /**
       * Prompt Template Text
       * @description Text of the prompt.
       */
      text: string;
      /**
       * Prompt Template Version
       * @description Version of the prompt template.
       */
      version: string;
    };
    /**
     * PublicPromptTemplateSelectResult
     * @description Result of a prompt template select operation.
     */
    PublicPromptTemplateSelectResult: {
      [key: string]: unknown;
    };
    /** QueryDocumentsParams */
    QueryDocumentsParams: {
      /**
       * All Terms Must Match
       * @description Specifies if returned documents must match all query terms.
       */
      all_terms_must_match?: boolean | null;
      /**
       * Custom Query
       * @description Sends a custom query.
       */
      custom_query?: {
        [key: string]: unknown;
      } | null;
      /**
       * Efficient Filtering
       * @description Specifies if efficient filtering should be used.
       */
      efficient_filtering?: boolean | null;
      /**
       * Haystack Filters
       * @description Filters you can use to narrow down the search. For more information, see [filtering logic](https://docs.cloud.deepset.ai/docs/filtering-logic).
       */
      filters?:
        | components['schemas']['LogicalCondition']
        | components['schemas']['ComparisonCondition']
        | components['schemas']['EmptyFilters']
        | null;
      /**
       * Query
       * @description The search query.
       */
      query?: string | null;
      /**
       * Query Emb
       * @description The vector representation of the query.
       */
      query_emb?: number[] | null;
      /**
       * Return Embedding
       * @description Returns vector representations of the documents.
       */
      return_embedding?: boolean | null;
      /**
       * Top K
       * @description The number of results to return.
       * @default 10
       */
      top_k: number;
      /**
       * Use Prefiltering
       * @deprecated
       * @description Specifies if documents should be prefiltered in the document store instead of within the retriever. DEPRECATED: This parameter will be removed in a future version. Use efficient_filtering parameter instead.
       */
      use_prefiltering?: boolean | null;
    };
    /**
     * RBACRoleController
     * @description A response model for the RBACRole.
     *     This is used to return the RBACRole to the client.
     */
    RBACRoleController: {
      /**
       * Description
       * @description The description of the role
       */
      description: string | null;
      /**
       * Permissions
       * @description The permissions of the role
       */
      permissions: components['schemas']['Permission'][];
      /**
       * Role
       * @description The name of the role
       */
      role: string;
      /**
       * Role Id
       * @description The ID of the role
       */
      role_id: string | null;
    };
    /** RawHaystackDocument */
    RawHaystackDocument: {
      /** Content */
      content?:
        | string
        | {
            [key: string]: unknown;
          }
        | unknown[]
        | null;
      /** Embedding */
      embedding?: number[] | null;
      /** Id */
      id: string;
      /**
       * Meta
       * @default {}
       */
      meta: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
    };
    /**
     * Roles
     * @enum {string}
     */
    Roles: Roles;
    /**
     * SchemaDefinitions
     * @description All definitions
     *
     *     We distinguish between components and types (primitives).
     */
    SchemaDefinitions: {
      /**
       * Components
       * @description Components of the schema
       */
      Components: {
        [key: string]: unknown;
      };
      /**
       * Haystacktypes
       * @description Types of the schema
       */
      haystackTypes: {
        [key: string]: unknown;
      };
    };
    /** SearchCount */
    SearchCount: {
      /**
       * Query Count
       * @description Number of queries that were sent.
       */
      count: number;
      /**
       * Search Count Dates
       * @description Date of the counted search queries.
       */
      date: string;
    };
    /** Pipeline List */
    SearchCountList: components['schemas']['SearchCount'][];
    /** SearchCountPagination */
    SearchCountPagination: {
      data: components['schemas']['SearchCountList'];
      /** Has More */
      has_more: boolean | null;
      /** Total */
      total: number | null;
    };
    /** Search History */
    SearchHistory: {
      /**
       * Query Duration
       * @description Duration of the query in milliseconds.
       */
      duration: number;
      pipeline: components['schemas']['PipelineName'];
      /**
       * Query Request
       * @description Query request.
       */
      request: {
        [key: string]: unknown;
      };
      /**
       * Response List
       * @description Response list from Haystack open source.
       */
      response: components['schemas']['SearchResultHistoryEntry'][];
      /**
       * Search history ID
       * Format: uuid
       * @description Unique identifier of the search.
       */
      search_history_id: string;
      /**
       * Search Session ID
       * @description The ID of the search session you want to use for chat.
       */
      session_id?: string | null;
      /**
       * Query Time
       * Format: date-time
       * @description Timestamp when the query was sent.
       */
      time: string;
      user: components['schemas']['UserIdName'];
    };
    /** SearchHistoryPagination */
    SearchHistoryPagination: {
      /** Data */
      data: components['schemas']['SearchHistory'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
    };
    /** SearchHistoryResultData */
    SearchHistoryResultData: {
      /** Answer */
      answer: string | null;
      /** Context */
      context:
        | string
        | {
            [key: string]: unknown;
          }
        | unknown[]
        | null;
      /** Documents */
      documents: {
        [key: string]: unknown;
      }[];
      /** Files */
      files: components['schemas']['PipelineFeedbackFile'][];
      /** Meta */
      meta: {
        [key: string]: unknown;
      } | null;
      /** Offsets In Context */
      offsets_in_context:
        | {
            [key: string]: number;
          }[]
        | null;
      /** Prompt */
      prompt: string | null;
      /**
       * Query Id
       * Format: uuid
       */
      query_id: string;
      /** Rank */
      rank: number | null;
      /** Score */
      score: number | null;
      search: components['schemas']['FeedbackSearchQuery'];
      /**
       * Search History Result Id
       * Format: uuid
       */
      search_history_result_id: string;
      /** Type */
      type: string;
    };
    /** SearchHistoryV2 */
    SearchHistoryV2: {
      /** Debug */
      _debug?: {
        [key: string]: unknown;
      } | null;
      /**
       * Answers
       * @description List of deepset answers.
       * @default []
       */
      answers: components['schemas']['DeepsetCloudAnswer'][];
      /**
       * Created At
       * Format: date-time
       * @description Specifies when the search query was run.
       */
      created_at: string;
      /**
       * Documents
       * @description List of deepset documents.
       * @default []
       */
      documents: components['schemas']['DeepsetCloudDocument'][];
      /**
       * Duration
       * @description The number of seconds the pipeline took to find the answer.
       */
      duration: number;
      /**
       * Haystack Filters
       * @description Filters you can use to narrow down the search. For more information, see [filtering logic](https://docs.cloud.deepset.ai/docs/filtering-logic).
       */
      filters?: {
        [key: string]: unknown;
      } | null;
      /**
       * Prompts
       * @description The prompts used in the query. This is only returned if the `view_prompts` flag is set to `true`.
       */
      prompts?: {
        [key: string]: string;
      } | null;
      /**
       * Query
       * @description The search query.
       */
      query: string;
      /**
       * Query ID
       * Format: uuid
       * @description Unique identifier of the search query.
       */
      query_id?: string;
      /**
       * Search Session ID
       * @description The ID of the search session you want to use for chat.
       */
      session_id?: string | null;
    };
    /** SearchResult */
    SearchResult: {
      /**
       * Query
       * @description The search query.
       */
      query_id?: string | null;
      /**
       * Search Results
       * @description List of search results.
       */
      results: components['schemas']['DeepsetCloudQueryResponse'][];
    };
    /** SearchResultHistoryEntry */
    SearchResultHistoryEntry: {
      /**
       * Search Result Documents
       * @description Documents that contain the search result.
       */
      documents: {
        [key: string]: unknown;
      }[];
      /**
       * Search Result Rank
       * @description The rank of the search result. A lower value means more relevant result.
       */
      rank?: number | null;
      /**
       * Search Results
       * @description List of search results.
       */
      result?: {
        [key: string]: unknown;
      } | null;
      /**
       * Search Result Score
       * @description The score of the search result.
       */
      score?: number | null;
      /**
       * Search Results
       * Format: uuid
       * @description List of search results.
       */
      search_result_history_id: string;
      /**
       * Search Result Type
       * @description The type of the search result. This can be either 'document' or 'answer'.
       */
      type: number;
    };
    /** SearchSessionGetResponse */
    SearchSessionGetResponse: {
      /**
       * Pipeline ID
       * Format: uuid
       * @description Unique identifier of a pipeline.
       */
      pipeline_id: string;
      /**
       * Query Request
       * @description Query request.
       */
      search_history?: components['schemas']['SearchSessionSearchHistoryEntry'] | null;
      /**
       * Search Session ID
       * Format: uuid
       * @description The ID of the search session you want to use for chat.
       */
      search_session_id: string;
    };
    /** SearchSessionPostBody */
    SearchSessionPostBody: {
      /**
       * Pipeline ID
       * Format: uuid
       * @description Unique identifier of a pipeline.
       */
      pipeline_id: string;
    };
    /** SearchSessionPostResponse */
    SearchSessionPostResponse: {
      /**
       * Search Session ID
       * Format: uuid
       * @description The ID of the search session you want to use for chat.
       */
      search_session_id: string;
    };
    /** SearchSessionSearchHistoryEntry */
    SearchSessionSearchHistoryEntry: {
      /**
       * Created At
       * @description Specifies when the search query was run.
       */
      created_at: string;
      /**
       * Query
       * @description The search query.
       */
      query: string;
      /**
       * Search history ID
       * Format: uuid
       * @description Unique identifier of the search.
       */
      search_history_id: string;
    };
    /** Get Secret */
    Secret: {
      /**
       * Secret Name
       * @description The name of the secret.
       */
      name: string;
      /**
       * Secret ID
       * Format: uuid
       * @description Unique identifier of the secret.
       */
      secret_id: string;
    };
    /** Get Secret */
    SecretPagination: {
      /** Data */
      data: components['schemas']['Secret'][];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** Session */
    Session: {
      /**
       * Session Created At
       * Format: date-time
       * @description The time when the session was created.
       */
      created_at: string;
      /**
       * Session Created By User
       * @description The user who created the session.
       */
      created_by: components['schemas']['UserIdName'];
      /**
       * Session Expires At
       * @description The time when the session expires.
       */
      expires_at: string | null;
      /**
       * Session ID
       * Format: uuid
       * @description Unique identifier of a session.
       */
      session_id?: string;
      /**
       * Session Status
       * @description The status of the upload session. The status can be 'OPEN' or 'CLOSED'.
       * @default OPEN
       */
      status: components['schemas']['SessionStatusEnum'];
      /**
       * Write Mode
       * @description Determines how to handle files that already exist. You can KEEP the existing file, OVERWRITE it, or FAIL to ingest if a file with the same name is already in your workspace.
       * @default KEEP
       */
      write_mode: components['schemas']['FileWriteModeEnum'];
    };
    /** SessionDetail */
    SessionDetail: {
      /**
       * Session Documentation URL
       * @description The URL to the documentation of the session.
       * @default https://docs.cloud.deepset.ai/docs/upload-files
       */
      documentation_url: string;
      /**
       * Session Expires At
       * @description The time when the session expires.
       */
      expires_at: string | null;
      /**
       * Ingestion status
       * @description The status of the ingestion process for this file.
       */
      ingestion_status: components['schemas']['FileIngestionStatus'];
      /**
       * Session ID
       * Format: uuid
       * @description Unique identifier of a session.
       */
      session_id?: string;
      /**
       * Session Status
       * @description The status of the upload session. The status can be 'OPEN' or 'CLOSED'.
       * @default OPEN
       */
      status: components['schemas']['SessionStatusEnum'];
      /**
       * Write Mode
       * @description Determines how to handle files that already exist. You can KEEP the existing file, OVERWRITE it, or FAIL to ingest if a file with the same name is already in your workspace.
       * @default KEEP
       */
      write_mode: components['schemas']['FileWriteModeEnum'];
    };
    /** SessionFile */
    SessionFile: {
      /**
       * Ingested File ID
       * Format: uuid
       * @description The ID of the ingested file.
       */
      file_ingestion_id?: string;
      /**
       * Ingested File Ingestion Status
       * @description The ingestion status of the ingested file.
       */
      ingestion_status: components['schemas']['FileIngestionStatusEnum'];
      /**
       * Explanation of the Ingestion Status
       * @description The ingestion status message that explains the ingestion status. This is only available for files that failed to ingest.
       */
      ingestion_status_reason?: components['schemas']['FileIngestionStatusReasonEnum'] | null;
      /**
       * Ingested File Name
       * @description The name of the ingested file.
       */
      name: string;
    };
    /**
     * SessionStatusEnum
     * @enum {string}
     */
    SessionStatusEnum: SessionStatusEnum;
    /** SharedPrototype */
    SharedPrototype: {
      /**
       * Brand Color
       * @description Specify a hexadecimal color code to represent the branding of the shared prototype.
       */
      brand_color?: string | null;
      /**
       * Brand Logo
       * @description Provide a base64 encoded string of the brand logo image.
       */
      brand_logo?: string | null;
      /**
       * Created by ID
       * Format: uuid
       * @description Unique ID of the user who created the shared prototype.
       */
      created_by_id: string;
      /**
       * Description
       * @description Explain how you expect the users to use this pipeline. Users who visit the shared prototype will see this text. For more information on how to set the right expectations regarding your pipeline, see [Guidelines for Onboarding Your Users](https://docs.cloud.deepset.ai/docs/guidelines-for-onboarding-your-users).
       */
      description?: string | null;
      /**
       * Expiration date
       * Format: date-time
       * @description The date after which the generated link will expire and become invalid. The expiration date must be within 60 days from the current date.
       */
      expiration_date: string;
      /**
       * Is revoked
       * @description If a prototype is revoked, it's no longer accessible with the link.
       */
      is_revoked: boolean;
      /**
       * Link
       * @description The generated link to the shared pipelines.
       */
      link: string;
      /**
       * Login required
       * @description Select whether users need to log in to access the shared prototype.
       * @default false
       */
      login_required: boolean;
      /**
       * Pipeline names
       * @description The names of the pipelines which you want to share.
       */
      pipeline_names: string[];
      /**
       * Pipeline names
       * @description The names of the pipelines which this prototype shares.
       */
      shared_pipelines: components['schemas']['PipelineName'][];
      /**
       * Shared Prototype ID
       * Format: uuid
       * @description The ID of the shared prototype
       */
      shared_prototype_id: string;
      /**
       * Show files
       * @description Select `True` if you want your users to be able to view the pipeline files.
       * @default false
       */
      show_files: boolean;
      /**
       * Show metadata filters
       * @description Select `True` if you want your users to be able to filter the documents by metadata.
       * @default false
       */
      show_metadata_filters: boolean;
    };
    /**
     * SortingOrderEnum
     * @enum {string}
     */
    SortingOrderEnum: SortingOrderEnum;
    /** StreamingQuery */
    StreamingQuery: {
      /**
       * Debug Flag
       * @description Shows debug output for the pipeline (for example, prompt).
       * @default false
       */
      debug: boolean | null;
      /**
       * Files
       * @description A list of files in the workspace.
       */
      files?: string[] | null;
      /**
       * Haystack Filters
       * @description Filters you can use to narrow down the search. For more information, see [filtering logic](https://docs.cloud.deepset.ai/docs/filtering-logic).
       */
      filters?:
        | components['schemas']['LogicalCondition']
        | components['schemas']['ComparisonCondition']
        | components['schemas']['EmptyFilters']
        | null;
      /**
       * Include Result
       * @description Includes the result of the pipeline at the end of the stream under key 'result'.
       * @default false
       */
      include_result: boolean;
      /**
       * Pipeline Parameters
       * @description Parameters you can use to customize the pipeline. For details, see [Haystack documentation for the pipeline `run()` method](https://docs.haystack.deepset.ai/reference/pipeline-api). These filters can be used to pass additional parameters to the pipeline.(Haystack is the underlying technology for deepset.)
       */
      params?: {
        [key: string]: unknown;
      } | null;
      /**
       * Query
       * @description The search query.
       */
      query: string;
      /**
       * Search Session ID
       * @description The ID of the search session you want to use for chat.
       */
      search_session_id?: string | null;
      /**
       * View prompts
       * @description Adds the runtime prompts of all nodes to the response. (Pipeline runs in debug mode.)
       * @default false
       */
      view_prompts: boolean;
    };
    /** SupportRequest */
    SupportRequest: {
      /**
       * Description
       * @description Describe the issue you are facing.
       */
      description: string;
      /**
       * Support request type
       * @description What kind of request do you have?
       */
      request_type: components['schemas']['SupportRequestType'];
      /**
       * User blocked description
       * @description How does the issue affect you?
       */
      user_blocked_description?: components['schemas']['UserBlockedDescription'] | null;
    };
    /**
     * SupportRequestType
     * @enum {string}
     */
    SupportRequestType: SupportRequestType;
    /** Tag */
    Tag: {
      /**
       * Tag Name
       * @description Name of the tag.
       */
      name: string;
      /**
       * Tag ID
       * Format: uuid
       * @description Unique identifier of the tag.
       */
      tag_id: string;
    };
    /** Token Meta */
    Token: {
      /**
       * All Workspaces
       * @default false
       */
      all_workspaces: boolean;
      /**
       * API Token ID
       * Format: uuid
       * @description Unique identifier of the API token.
       */
      api_token_id: string;
      /**
       * API Token Expires
       * @description Specifies whether the API token expires.
       */
      expires: boolean;
      /**
       * API Token Expiry
       * @description The date and time when the token expires. The timestamp is in the ISO 8601 format and follows the convention YYY-MM-DDTHH:MM:SS.sssZ. For more information, see [Date-Time](https://docs.cloud.deepset.ai/reference/api-best-practices#date-time).
       */
      expires_at: string | null;
      /**
       * API Token
       * @description The masked API token. The first and last 4 characters are visible, the rest is masked.
       */
      masked_token: string;
      /**
       * API Token Name
       * @description The name of the API token.
       */
      name: string;
      /**
       * API Token type
       * @description Indicates if the API token is a personal or service level token.
       */
      personal: boolean;
      role: components['schemas']['Roles'];
      user: components['schemas']['UserName'];
      /** Workspaces */
      workspaces: components['schemas']['WorkspaceName'][];
    };
    /** Token List */
    TokenList: components['schemas']['Token'][];
    /** TokenPagination */
    TokenPagination: {
      data: components['schemas']['TokenList'];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** UpdateFeedback */
    UpdateFeedback: {
      /** Bookmarked */
      bookmarked?: boolean | null;
      /** Comment */
      comment?: string | null;
      /** Score */
      score?: string | null;
      /** Tags */
      tags?: string[] | null;
    };
    /** Bulk file metadata update request */
    UpdateFileMetaBulkRequest: {
      [key: string]: components['schemas']['FileMetadata'];
    };
    /** UpdateFileMetaBulkResponse */
    UpdateFileMetaBulkResponse: {
      /**
       * Failed file count
       * @description The number of files that failed to update.
       */
      failed_count: number;
      /**
       * Failed files
       * @description The files that failed to update.
       */
      failed_files: components['schemas']['FileUpdateError'][];
      /**
       * Updated file count
       * @description The number of files that were updated.
       */
      updated_count: number;
    };
    /**
     * Update Registry Token
     * @example {
     *       "token": "your-aws-bedrock-token"
     *     }
     */
    UpdateModelRegistryToken: {
      /**
       * Token
       * @description The new token.
       */
      token: string;
    };
    /** UpdatePipelineIndexRequest */
    UpdatePipelineIndexRequest: {
      /**
       * Pipeline Index Config YAML
       * @description Config YAML of the pipeline index.
       */
      config_yaml?: string | null;
      /**
       * Pipeline Index Description
       * @description Description of the pipeline index.
       */
      description?: string | null;
      /**
       * Pipeline Index Name
       * @description Name of the pipeline index.
       */
      name?: string | null;
    };
    /** UpdatePipelineYAMLRequest */
    UpdatePipelineYAMLRequest: {
      /**
       * deepset Version
       * @description The version of deepset the pipeline was created with.
       * @default v2
       */
      deepset_cloud_version: components['schemas']['DeepsetCloudVersion'];
      /**
       * Indexing YAML
       * @description The deepset pipeline YAML configuration for indexing.
       */
      indexing_yaml?: string | null;
      /**
       * Query YAML
       * @description The deepset pipeline YAML configuration for querying.
       */
      query_yaml?: string | null;
    };
    /** UpdateToken */
    UpdateToken: {
      /**
       * API Token Name
       * @description The name of the API token.
       */
      name: string;
      /**
       * API Token Role
       * @description The role of the API token. Defaults to the role of the user that created the token. Admin users can create tokens with any role.
       */
      role?: components['schemas']['Roles'] | null;
    };
    /** UploadFileResponse */
    UploadFileResponse: {
      /**
       * File ID
       * Format: uuid
       * @description Unique identifier of a file.
       */
      file_id: string;
    };
    /** UploadSession */
    UploadSession: {
      /**
       * AWS Prefix
       * @description The request configuration used for uploading files. Set each file key to `<org_id>/<workspace_id>/<session_id>/${filename}`, where filename is <file_name>.<txt|pdf> or <file_name>.<txt|pdf>.meta.json for meta files.
       */
      aws_prefixed_request_config: components['schemas']['PresignedPrefix'];
      /**
       * Session Documentation URL
       * @description The URL to the documentation of the session.
       * @default https://docs.cloud.deepset.ai/docs/upload-files
       */
      documentation_url: string;
      /**
       * Session Expires At
       * Format: date-time
       * @description The time when the session expires.
       */
      expires_at: string;
      /**
       * Session ID
       * Format: uuid
       * @description Unique identifier of a session.
       */
      session_id?: string;
    };
    /** User */
    User: {
      /**
       * Deleted
       * @description Indicates if a user is deleted.
       */
      deleted: boolean;
      /**
       * Email
       * @description Email of a user.
       */
      email?: string | null;
      /**
       * Family name
       * @description Family name of a user.
       */
      family_name: string;
      /**
       * Given name
       * @description Given name of a user.
       */
      given_name: string;
      /**
       * Oauth ID
       * @description Oauth ID from auth0
       */
      oauth_id: string | null;
      /**
       * Oauth Provider
       * @description Oauth provider from auth0. For example: 'auth0', 'google-auth', 'github', and the like.
       */
      oauth_provider: string;
      /**
       * Organization
       * @description The deepset organization the user belongs to.
       */
      organization: components['schemas']['OrganizationFormatted'];
      /**
       * User ID
       * Format: uuid
       * @description Unique identifier of a user.
       */
      user_id: string;
      /**
       * Userflow Signature
       * @description Userflow signature.
       */
      userflow_signature: string;
    };
    /**
     * UserBlockedDescription
     * @enum {string}
     */
    UserBlockedDescription: UserBlockedDescription;
    /** Oauth User */
    UserIdName: {
      /**
       * Family name
       * @description Family name of a user.
       */
      family_name: string;
      /**
       * Given name
       * @description Given name of a user.
       */
      given_name: string;
      /**
       * User ID
       * Format: uuid
       * @description Unique identifier of a user.
       */
      user_id: string;
    };
    /** User Invitation */
    UserInvitation: {
      /**
       * Email
       * @description Email of a user.
       */
      email: string;
      /**
       * Family name
       * @description Family name of a user.
       */
      family_name: string;
      /**
       * Given name
       * @description Given name of a user.
       */
      given_name: string;
      role: components['schemas']['Roles'];
      /**
       * Workspace IDs
       * @description A list of unique identifiers for workspaces.
       * @default []
       */
      workspace_ids: string[];
    };
    /** User List */
    UserList: components['schemas']['User'][];
    /** User Name */
    UserName: {
      /**
       * Family name
       * @description Family name of a user.
       */
      family_name: string;
      /**
       * Given name
       * @description Given name of a user.
       */
      given_name: string;
    };
    /** UserPagination */
    UserPagination: {
      data: components['schemas']['UserList'];
      /**
       * Has more results
       * @description Indicates if there are more results to show.
       */
      has_more: boolean;
      /**
       * Total number of results
       * @description The total number of results matching your query.
       */
      total: number;
    };
    /** UserRole */
    UserRole: {
      role: components['schemas']['Roles'];
    };
    /** ValidatePipelineYaml */
    ValidatePipelineYaml: {
      /**
       * deepset Version
       * @description The version of deepset the pipeline was created with.
       * @default v2
       */
      deepset_cloud_version: components['schemas']['DeepsetCloudVersion'];
      /**
       * Indexing YAML
       * @description The deepset pipeline YAML configuration for indexing.
       */
      indexing_yaml?: string | null;
      /**
       * Pipeline Name
       * @description Name of the pipeline.
       */
      name?: string | null;
      /**
       * Pipeline Index ID
       * @description Unique identifier of the pipeline index.
       */
      pipeline_index_id?: string | null;
      /**
       * Query YAML
       * @description The deepset pipeline YAML configuration for querying.
       */
      query_yaml?: string | null;
    };
    /** ValidationError */
    ValidationError: {
      /** Location */
      loc: (string | number)[];
      /** Message */
      msg: string;
      /** Error Type */
      type: string;
    };
    /** Workspace */
    Workspace: {
      /**
       * Workspace default idle timeout
       * @description Default idle timeout for pipelines. Pipelines will go on standby after this time. Reach out to deepset support to change this limit.
       */
      default_idle_timeout_in_seconds?: number | null;
      /**
       * Workspace languages
       * @description Supported languages within a workspace.
       */
      languages?: {
        [key: string]: unknown;
      } | null;
      /**
       * Workspace name
       * @description The name of the workspace. It must be longer than 3 characters.
       */
      name: string;
      /**
       * Workspace ID
       * Format: uuid
       * @description Unique identifier of a workspace.
       */
      workspace_id: string;
    };
    /** WorkspaceDocumentStoreCredentials */
    WorkspaceDocumentStoreCredentials: {
      /**
       * Pipeline cluster credentials ID
       * Format: uuid
       * @description The ID of the credentials for the OpenSearch cluster you want to use to serve your deployed pipelines. Use the endpoint 'list_available_opensearch_credentials' to list all credentials available in your organization.
       */
      pipeline_document_store_credentials_id: string;
      /**
       * Workspace document store credentials ID
       * Format: uuid
       * @description The ID of the credentials for the OpenSearch cluster you want to use for managing the files in this workspace.Use the endpoint 'list_available_opensearch_credentials' to list all credentials available in your organization.
       */
      workspace_document_store_credentials_id: string;
    };
    /** WorkspaceFileStoreCredentials */
    WorkspaceFileStoreCredentials: {
      /**
       * File Store Credentials ID
       * Format: uuid
       * @description The ID of the credentials for the S3 bucket you want to use to serve your deployed pipelines. Use the endpoint 'list_available_s3_credentials' to list all credentials available in your organization.
       */
      file_store_credentials_id: string;
    };
    /** User List */
    WorkspaceList: components['schemas']['Workspace'][];
    /** WorkspaceName */
    WorkspaceName: {
      /**
       * Workspace name
       * @description The name of the workspace. It must be longer than 3 characters.
       */
      name: string;
    };
    /** WorkspaceStats */
    WorkspaceStats: {
      /**
       * Average response time
       * @description The average response time of the search requests in the workspace.
       */
      average_response_time: number;
      /**
       * Document count
       * @description Total number of documents in the workspace across all pipelines.
       */
      document_count: number;
      /**
       * File count
       * @description The number of files in the workspace.
       */
      file_count: number;
      /**
       * Search request count
       * @description The number of search requests made in the workspace.
       */
      search_request_count: number;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type SchemaApiTokenResult = components['schemas']['APITokenResult'];
export type SchemaAwsAssumeRoleCredentials = components['schemas']['AWSAssumeRoleCredentials'];
export type SchemaAction = components['schemas']['Action'];
export type SchemaAddRoleBody = components['schemas']['AddRoleBody'];
export type SchemaAssetCollection = components['schemas']['AssetCollection'];
export type SchemaAssetInfo = components['schemas']['AssetInfo'];
export type SchemaAssets = components['schemas']['Assets'];
export type SchemaAssignedRoleRequest = components['schemas']['AssignedRoleRequest'];
export type SchemaBodyImportCustomComponentsApiV2CustomComponentsPost =
  components['schemas']['Body_import_custom_components_api_v2_custom_components_post'];
export type SchemaBodyUploadFileApiV1WorkspacesWorkspaceNameFilesPost =
  components['schemas']['Body_upload_file_api_v1_workspaces__workspace_name__files_post'];
export type SchemaBodyUploadTemporaryFileApiV1WorkspacesWorkspaceNameTemporaryFilesPost =
  components['schemas']['Body_upload_temporary_file_api_v1_workspaces__workspace_name__temporary_files_post'];
export type SchemaChatQuery = components['schemas']['ChatQuery'];
export type SchemaChatStreamingQuery = components['schemas']['ChatStreamingQuery'];
export type SchemaCloseSession = components['schemas']['CloseSession'];
export type SchemaComparisonCondition = components['schemas']['ComparisonCondition'];
export type SchemaComparisonOperator = components['schemas']['ComparisonOperator'];
export type SchemaComponentDomain = components['schemas']['ComponentDomain'];
export type SchemaComponentPosition = components['schemas']['ComponentPosition'];
export type SchemaComponentVisualizationMetadata =
  components['schemas']['ComponentVisualizationMetadata'];
export type SchemaCountDocumentsParams = components['schemas']['CountDocumentsParams'];
export type SchemaCreateFeedback = components['schemas']['CreateFeedback'];
export type SchemaCreateModelRegistryToken = components['schemas']['CreateModelRegistryToken'];
export type SchemaCreatePipeline = components['schemas']['CreatePipeline'];
export type SchemaCreatePipelineIndexRequest = components['schemas']['CreatePipelineIndexRequest'];
export type SchemaCreateSecret = components['schemas']['CreateSecret'];
export type SchemaCreateSession = components['schemas']['CreateSession'];
export type SchemaCreateTag = components['schemas']['CreateTag'];
export type SchemaCreateToken = components['schemas']['CreateToken'];
export type SchemaCustomComponent = components['schemas']['CustomComponent'];
export type SchemaCustomComponentLog = components['schemas']['CustomComponentLog'];
export type SchemaDcDocumentCount = components['schemas']['DCDocumentCount'];
export type SchemaDataset = components['schemas']['Dataset'];
export type SchemaDatasetPagination = components['schemas']['DatasetPagination'];
export type SchemaDebugTunnelDeviceLoginCredentials =
  components['schemas']['DebugTunnelDeviceLoginCredentials'];
export type SchemaDeepsetCloudAnswer = components['schemas']['DeepsetCloudAnswer'];
export type SchemaDeepsetCloudDocument = components['schemas']['DeepsetCloudDocument'];
export type SchemaDeepsetCloudQueryResponse = components['schemas']['DeepsetCloudQueryResponse'];
export type SchemaDeepsetCloudSchema = components['schemas']['DeepsetCloudSchema'];
export type SchemaDeepsetCloudSpan = components['schemas']['DeepsetCloudSpan'];
export type SchemaDeepsetCloudTableCell = components['schemas']['DeepsetCloudTableCell'];
export type SchemaDeepsetCloudVersion = components['schemas']['DeepsetCloudVersion'];
export type SchemaEmptyFilters = components['schemas']['EmptyFilters'];
export type SchemaEntityRole = components['schemas']['EntityRole'];
export type SchemaExceptionTraceLog = components['schemas']['ExceptionTraceLog'];
export type SchemaExternalFacingDocumentStoreCredentials =
  components['schemas']['ExternalFacingDocumentStoreCredentials'];
export type SchemaExternalS3Credentials = components['schemas']['ExternalS3Credentials'];
export type SchemaFeedback = components['schemas']['Feedback'];
export type SchemaFeedbackSearchQuery = components['schemas']['FeedbackSearchQuery'];
export type SchemaFeedbackSelectResult = components['schemas']['FeedbackSelectResult'];
export type SchemaFeedbackStats = components['schemas']['FeedbackStats'];
export type SchemaFeedbackTag = components['schemas']['FeedbackTag'];
export type SchemaFetchDocumentsParams = components['schemas']['FetchDocumentsParams'];
export type SchemaFile = components['schemas']['File'];
export type SchemaFileId = components['schemas']['FileId'];
export type SchemaFileIngestionStatus = components['schemas']['FileIngestionStatus'];
export type SchemaFileIngestionStatusEnum = components['schemas']['FileIngestionStatusEnum'];
export type SchemaFileIngestionStatusReasonEnum =
  components['schemas']['FileIngestionStatusReasonEnum'];
export type SchemaFileMetadata = components['schemas']['FileMetadata'];
export type SchemaFileNames = components['schemas']['FileNames'];
export type SchemaFilePagination = components['schemas']['FilePagination'];
export type SchemaFileStatus = components['schemas']['FileStatus'];
export type SchemaFileUpdateError = components['schemas']['FileUpdateError'];
export type SchemaFileWriteModeEnum = components['schemas']['FileWriteModeEnum'];
export type SchemaGenerateIntegratedYamlData = components['schemas']['GenerateIntegratedYamlData'];
export type SchemaHttpValidationError = components['schemas']['HTTPValidationError'];
export type SchemaHaystackComponentInitParams =
  components['schemas']['HaystackComponentInitParams'];
export type SchemaHaystackComponentInputOutputSchema =
  components['schemas']['HaystackComponentInputOutputSchema'];
export type SchemaHaystackComponentSchema = components['schemas']['HaystackComponentSchema'];
export type SchemaLogOrigin = components['schemas']['LogOrigin'];
export type SchemaLogicalCondition = components['schemas']['LogicalCondition'];
export type SchemaLogicalOperator = components['schemas']['LogicalOperator'];
export type SchemaModelMeta = components['schemas']['ModelMeta'];
export type SchemaModelProvider = components['schemas']['ModelProvider'];
export type SchemaModelRegistryToken = components['schemas']['ModelRegistryToken'];
export type SchemaNewOpenSearchVpcCredentials =
  components['schemas']['NewOpenSearchVPCCredentials'];
export type SchemaNewS3Credentials = components['schemas']['NewS3Credentials'];
export type SchemaNewWorkspace = components['schemas']['NewWorkspace'];
export type SchemaOrganizationFormatted = components['schemas']['OrganizationFormatted'];
export type SchemaOrganizationName = components['schemas']['OrganizationName'];
export type SchemaOrganizationType = components['schemas']['OrganizationType'];
export type SchemaPaginatedCustomComponents = components['schemas']['PaginatedCustomComponents'];
export type SchemaPaginatedFeedback = components['schemas']['PaginatedFeedback'];
export type SchemaPaginatedPipelineTemplates = components['schemas']['PaginatedPipelineTemplates'];
export type SchemaPaginatedPromptTemplates = components['schemas']['PaginatedPromptTemplates'];
export type SchemaPaginatedPublicPromptTemplates =
  components['schemas']['PaginatedPublicPromptTemplates'];
export type SchemaPaginatedSearchSessions = components['schemas']['PaginatedSearchSessions'];
export type SchemaPaginatedSession = components['schemas']['PaginatedSession'];
export type SchemaPaginatedSessionFile = components['schemas']['PaginatedSessionFile'];
export type SchemaPaginatedSharedPrototypes = components['schemas']['PaginatedSharedPrototypes'];
export type SchemaPaginatedTags = components['schemas']['PaginatedTags'];
export type SchemaPatchSharedPrototype = components['schemas']['PatchSharedPrototype'];
export type SchemaPermission = components['schemas']['Permission'];
export type SchemaPipeline = components['schemas']['Pipeline'];
export type SchemaPipelineExceptionLog = components['schemas']['PipelineExceptionLog'];
export type SchemaPipelineFeedbackFile = components['schemas']['PipelineFeedbackFile'];
export type SchemaPipelineFieldSearchResult = components['schemas']['PipelineFieldSearchResult'];
export type SchemaPipelineIndex = components['schemas']['PipelineIndex'];
export type SchemaPipelineIndexDesiredStatus = components['schemas']['PipelineIndexDesiredStatus'];
export type SchemaPipelineIndexMetadataProperty =
  components['schemas']['PipelineIndexMetadataProperty'];
export type SchemaPipelineIndexMetadataPropertyWithNesting =
  components['schemas']['PipelineIndexMetadataPropertyWithNesting'];
export type SchemaPipelineIndexPagination = components['schemas']['PipelineIndexPagination'];
export type SchemaPipelineIndexingStatusDetail =
  components['schemas']['PipelineIndexingStatusDetail'];
export type SchemaPipelineIssue = components['schemas']['PipelineIssue'];
export type SchemaPipelineIssues = components['schemas']['PipelineIssues'];
export type SchemaPipelineLog = components['schemas']['PipelineLog'];
export type SchemaPipelineLogPagination = components['schemas']['PipelineLogPagination'];
export type SchemaPipelineMetadataAggregation =
  components['schemas']['PipelineMetadataAggregation'];
export type SchemaPipelineName = components['schemas']['PipelineName'];
export type SchemaPipelinePagination = components['schemas']['PipelinePagination'];
export type SchemaPipelinePrompt = components['schemas']['PipelinePrompt'];
export type SchemaPipelinePrompts = components['schemas']['PipelinePrompts'];
export type SchemaPipelineQuery = components['schemas']['PipelineQuery'];
export type SchemaPipelineServiceLevelEnum = components['schemas']['PipelineServiceLevelEnum'];
export type SchemaPipelineServiceLevelWithDraftEnum =
  components['schemas']['PipelineServiceLevelWithDraftEnum'];
export type SchemaPipelineStatistics = components['schemas']['PipelineStatistics'];
export type SchemaPipelineStatus = components['schemas']['PipelineStatus'];
export type SchemaPipelineTemplate = components['schemas']['PipelineTemplate'];
export type SchemaPipelineTemplateSelectResult =
  components['schemas']['PipelineTemplateSelectResult'];
export type SchemaPipelineType = components['schemas']['PipelineType'];
export type SchemaPipelineUpdateRequest = components['schemas']['PipelineUpdateRequest'];
export type SchemaPipelineVisualizationMetadataInput =
  components['schemas']['PipelineVisualizationMetadata-Input'];
export type SchemaPipelineVisualizationMetadataOutput =
  components['schemas']['PipelineVisualizationMetadata-Output'];
export type SchemaPipelineYamlConfiguration = components['schemas']['PipelineYAMLConfiguration'];
export type SchemaPostSharedPrototype = components['schemas']['PostSharedPrototype'];
export type SchemaPresignedPrefix = components['schemas']['PresignedPrefix'];
export type SchemaPromptTemplate = components['schemas']['PromptTemplate'];
export type SchemaPromptTemplatePost = components['schemas']['PromptTemplatePost'];
export type SchemaPromptTemplatePut = components['schemas']['PromptTemplatePut'];
export type SchemaPromptTemplateSelectResult = components['schemas']['PromptTemplateSelectResult'];
export type SchemaPublicPromptTemplate = components['schemas']['PublicPromptTemplate'];
export type SchemaPublicPromptTemplateSelectResult =
  components['schemas']['PublicPromptTemplateSelectResult'];
export type SchemaQueryDocumentsParams = components['schemas']['QueryDocumentsParams'];
export type SchemaRbacRoleController = components['schemas']['RBACRoleController'];
export type SchemaRawHaystackDocument = components['schemas']['RawHaystackDocument'];
export type SchemaRoles = components['schemas']['Roles'];
export type SchemaSchemaDefinitions = components['schemas']['SchemaDefinitions'];
export type SchemaSearchCount = components['schemas']['SearchCount'];
export type SchemaSearchCountList = components['schemas']['SearchCountList'];
export type SchemaSearchCountPagination = components['schemas']['SearchCountPagination'];
export type SchemaSearchHistory = components['schemas']['SearchHistory'];
export type SchemaSearchHistoryPagination = components['schemas']['SearchHistoryPagination'];
export type SchemaSearchHistoryResultData = components['schemas']['SearchHistoryResultData'];
export type SchemaSearchHistoryV2 = components['schemas']['SearchHistoryV2'];
export type SchemaSearchResult = components['schemas']['SearchResult'];
export type SchemaSearchResultHistoryEntry = components['schemas']['SearchResultHistoryEntry'];
export type SchemaSearchSessionGetResponse = components['schemas']['SearchSessionGetResponse'];
export type SchemaSearchSessionPostBody = components['schemas']['SearchSessionPostBody'];
export type SchemaSearchSessionPostResponse = components['schemas']['SearchSessionPostResponse'];
export type SchemaSearchSessionSearchHistoryEntry =
  components['schemas']['SearchSessionSearchHistoryEntry'];
export type SchemaSecret = components['schemas']['Secret'];
export type SchemaSecretPagination = components['schemas']['SecretPagination'];
export type SchemaSession = components['schemas']['Session'];
export type SchemaSessionDetail = components['schemas']['SessionDetail'];
export type SchemaSessionFile = components['schemas']['SessionFile'];
export type SchemaSessionStatusEnum = components['schemas']['SessionStatusEnum'];
export type SchemaSharedPrototype = components['schemas']['SharedPrototype'];
export type SchemaSortingOrderEnum = components['schemas']['SortingOrderEnum'];
export type SchemaStreamingQuery = components['schemas']['StreamingQuery'];
export type SchemaSupportRequest = components['schemas']['SupportRequest'];
export type SchemaSupportRequestType = components['schemas']['SupportRequestType'];
export type SchemaTag = components['schemas']['Tag'];
export type SchemaToken = components['schemas']['Token'];
export type SchemaTokenList = components['schemas']['TokenList'];
export type SchemaTokenPagination = components['schemas']['TokenPagination'];
export type SchemaUpdateFeedback = components['schemas']['UpdateFeedback'];
export type SchemaUpdateFileMetaBulkRequest = components['schemas']['UpdateFileMetaBulkRequest'];
export type SchemaUpdateFileMetaBulkResponse = components['schemas']['UpdateFileMetaBulkResponse'];
export type SchemaUpdateModelRegistryToken = components['schemas']['UpdateModelRegistryToken'];
export type SchemaUpdatePipelineIndexRequest = components['schemas']['UpdatePipelineIndexRequest'];
export type SchemaUpdatePipelineYamlRequest = components['schemas']['UpdatePipelineYAMLRequest'];
export type SchemaUpdateToken = components['schemas']['UpdateToken'];
export type SchemaUploadFileResponse = components['schemas']['UploadFileResponse'];
export type SchemaUploadSession = components['schemas']['UploadSession'];
export type SchemaUser = components['schemas']['User'];
export type SchemaUserBlockedDescription = components['schemas']['UserBlockedDescription'];
export type SchemaUserIdName = components['schemas']['UserIdName'];
export type SchemaUserInvitation = components['schemas']['UserInvitation'];
export type SchemaUserList = components['schemas']['UserList'];
export type SchemaUserName = components['schemas']['UserName'];
export type SchemaUserPagination = components['schemas']['UserPagination'];
export type SchemaUserRole = components['schemas']['UserRole'];
export type SchemaValidatePipelineYaml = components['schemas']['ValidatePipelineYaml'];
export type SchemaValidationError = components['schemas']['ValidationError'];
export type SchemaWorkspace = components['schemas']['Workspace'];
export type SchemaWorkspaceDocumentStoreCredentials =
  components['schemas']['WorkspaceDocumentStoreCredentials'];
export type SchemaWorkspaceFileStoreCredentials =
  components['schemas']['WorkspaceFileStoreCredentials'];
export type SchemaWorkspaceList = components['schemas']['WorkspaceList'];
export type SchemaWorkspaceName = components['schemas']['WorkspaceName'];
export type SchemaWorkspaceStats = components['schemas']['WorkspaceStats'];
export type $defs = Record<string, never>;
export interface operations {
  get_available_components_api_v1_haystack_components_get: {
    parameters: {
      query?: {
        /** @description The service domain to fetch components for. */
        domain?: components['schemas']['ComponentDomain'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Schema for all available haystack components. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaystackComponentSchema'];
        };
      };
      /** @description Schema not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_components_input_output_api_v1_haystack_components_input_output_get: {
    parameters: {
      query?: {
        /** @description The service domain to fetch components for. */
        domain?: components['schemas']['ComponentDomain'];
        names?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Input and output schema for available components. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaystackComponentInputOutputSchema'][];
        };
      };
      /** @description Input and output schema not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_components_dynamic_input_output_api_v1_haystack_components_input_output_generate_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['HaystackComponentInitParams'][];
      };
    };
    responses: {
      /** @description Generated dynamic input output component schemas. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaystackComponentInputOutputSchema'][];
        };
      };
      /** @description Failed to generate dynamic input output schemas. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_available_opensearch_credentials_api_v1_infrastructure_document_stores_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of document store credentials that exist for the current organization. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExternalFacingDocumentStoreCredentials'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_opensearch_credentials_api_v1_infrastructure_document_stores_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NewOpenSearchVPCCredentials'];
      };
    };
    responses: {
      /** @description Credentials to your own OpenSearch cluster added. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExternalFacingDocumentStoreCredentials'];
        };
      };
      /** @description We couldn't add the credentials to your OpenSearch cluster. See the documentation for [how to obtain the correct credentials](https://docs.cloud.deepset.ai/docs/connect-your-own-file-storage). */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't create the connection to the OpenSearch domain you provided. Follow the instructions in the [documentation](https://docs.cloud.deepset.ai/docs/connect-your-own-file-storage) to allow deepset to connect to your OpenSearch domain. */
      412: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_opensearch_credentials_api_v1_infrastructure_document_stores__credentials_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the credentials you want to delete. Use the [List Available OpenSearch Credentials](https://docs.cloud.deepset.ai/reference/list_available_opensearch_credentials_api_v1_infrastructure_document_stores_get) endpoint to check the ID. */
        credentials_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Credentials to your own OpenSearch cluster deleted */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't delete the specified document store credentials because they are currently in use. Delete all workspaces which use these credentials and try again. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the specified credentials. Use the endpoint 'list_available_opensearch_credentials' for listing document store credentials in your organization and 'list_available_s3_credentials' for listing S3 credentials in your organization. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_available_s3_credentials_api_v1_infrastructure_file_stores_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of S3 bucket credentials that exist for the current organization. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExternalS3Credentials'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_s3_credentials_api_v1_infrastructure_file_stores_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NewS3Credentials'];
      };
    };
    responses: {
      /** @description Credentials to your own S3 bucket added */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExternalS3Credentials'];
        };
      };
      /** @description We couldn't create the connection to the S3 bucket you provided. Possible reasons are a wrong bucket name or missing bucket permissions. Check the response body for more details. See the documentation for [how to correctly configure the bucket permissions](https://docs.cloud.deepset.ai/). */
      412: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_s3_credentials_api_v1_infrastructure_file_stores__credentials_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the credentials you want to delete. Use the [List Available OpenSearch Credentials](https://docs.cloud.deepset.ai/reference/list_available_opensearch_credentials_api_v1_infrastructure_document_stores_get) endpoint to check the ID. */
        credentials_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Credentials to your own S3 bucket deleted. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't delete the specified S3 credentials because they are currently in use. Delete all workspaces which use these credentials and try again. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the specified S3 bucket credentials. Use the endpoint 'list_available_s3_buckets' to check the S3 bucket credentials that exist in your organization. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_users_me_api_v1_me_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_users_me_workspace_permissions_api_v1_me_workspaces__workspace_name__permissions_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Permission'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_model_api_v1_model_get: {
    parameters: {
      query?: {
        /** @description The model author from Hugging Face. For example, the author of the model 'deepset/minilm-uncased-squad2' is 'deepset'. You must specify the author if you don't specify the `node_type`. */
        author?: string | null;
        /** @description Specify component path, for example `haystack.components.joiners.branch.BranchJoiner`. For more information about components, see https://docs.cloud.deepset.ai/docs/pipeline-components. */
        node_type?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ModelMeta'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_token_deprecated_api_v1_model_registry_token_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ModelRegistryToken'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_token_deprecated_api_v1_model_registry_token_put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateModelRegistryToken'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_token_deprecated_api_v1_model_registry_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateModelRegistryToken'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_token_deprecated_api_v1_model_registry_token_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_tokens_api_v1_model_registry_tokens_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ModelRegistryToken'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_token_api_v1_model_registry_tokens__provider__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The provider of the model registry. */
        provider: components['schemas']['ModelProvider'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ModelRegistryToken'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_token_api_v1_model_registry_tokens__provider__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The provider of the model registry. */
        provider: components['schemas']['ModelProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateModelRegistryToken'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_token_api_v1_model_registry_tokens__provider__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The provider of the model registry. */
        provider: components['schemas']['ModelProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateModelRegistryToken'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_token_api_v1_model_registry_tokens__provider__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The provider of the model registry. */
        provider: components['schemas']['ModelProvider'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_organization_api_v1_organization_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationName'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_permissions_api_v1_organization_permissions_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AssetCollection'];
        };
      };
    };
  };
  invite_user_to_organization_api_v1_organization__organization_id__invitation_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the organization. You can obtain the organization ID from the [Get Users Me](https://docs.cloud.deepset.ai/reference/read_users_me_api_v1_me_get)  endpoint. */
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserInvitation'];
      };
    };
    responses: {
      /** @description The user has been invited to the organization. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Inviting users is not available on the free plan. To invite team members, please upgrade to a paid plan. */
      402: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The user already belongs to the organization. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Something went wrong during signup. */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_roles_api_v1_organization__organization_id__roles_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the organization */
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The roles that exist in the specified organization. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RBACRoleController'][];
        };
      };
      /** @description Organization not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_role_api_v1_organization__organization_id__roles_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the organization */
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddRoleBody'];
      };
    };
    responses: {
      /** @description The role that was added to the specified organization. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RBACRoleController'];
        };
      };
      /** @description Organization not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Role already exists */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_role_api_v1_organization__organization_id__roles__role_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the role */
        role_id: string;
        /** @description The ID of the organization */
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddRoleBody'];
      };
    };
    responses: {
      /** @description The role that was updated in the specified organization. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RBACRoleController'];
        };
      };
      /** @description Role not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Role already exists */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_role_api_v1_organization__organization_id__roles__role_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the role */
        role_id: string;
        /** @description The ID of the organization */
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The role that was deleted from the specified organization. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Role not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Cannot delete role. Role is still assigned to <some_number> user(s). */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_support_request_api_v1_organization__organization_id__support_request_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the organization. You can obtain the organization ID from the [Get Users Me](https://docs.cloud.deepset.ai/reference/read_users_me_api_v1_me_get)  endpoint. */
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SupportRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_integrated_pipeline_yaml_api_v1_pipeline_utils_yaml_integrate_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateIntegratedYamlData'];
      };
    };
    responses: {
      /** @description Returns a merged YAML file, integrating changes from the updated dictionary into the original YAML. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string;
        };
      };
      /** @description Raises an error when the request body is invalid. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_public_prompt_templates_api_v1_public_prompt_templates_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the entity you want to sort by. */
        field?: PathsApiV1Public_prompt_templatesGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1Public_prompt_templatesGetParametersQueryOrder;
        /** @description Partial implementation of the OData $select operator. It currently only supports selecting fields from the root entity or a child entity. Selecting fields from children's children is not supported. If you use this parameter, the API answer is always a flat list of distinct JSON objects with the selected properties, for example, '[{"given_name": "user1", "user_id": "..."}, ...]' for 'select=created_by/given_name, created_by/user_id'. The results are ordered by the first selected attribute. To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        select?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedPublicPromptTemplates'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_tokens_api_v1_token_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
        /** @description The name of the field you want to sort by. */
        field?: PathsApiV1TokenGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1TokenGetParametersQueryOrder;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TokenPagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_token_api_v1_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateToken'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['APITokenResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retrieve_token_api_v1_token__api_token_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the API token you want to delete. Call the Get Tokens endpoint to check the IDs of the existing API tokens. */
        api_token_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Token'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_token_api_v1_token__api_token_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the API token you want to delete. Call the Get Tokens endpoint to check the IDs of the existing API tokens. */
        api_token_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_token_api_v1_token__api_token_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the API token you want to delete. Call the Get Tokens endpoint to check the IDs of the existing API tokens. */
        api_token_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateToken'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_users_api_v1_users_get: {
    parameters: {
      query?: {
        /** @description Includes deleted users in the response. */
        include_deleted?: boolean;
        /** @description Includes external users in the response. */
        include_external?: boolean;
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserPagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_api_v1_users__user_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the user. You can obtain it from the Get Users endpoint. */
        user_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_api_v1_users__user_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the user. You can obtain it from the Get Users endpoint. */
        user_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_permission_api_v1_users__user_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the user. You can obtain it from the Get Users endpoint. */
        user_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserRole'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_role_api_v1_users__user_id__assign_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the user. You can obtain it from the Get Users endpoint. */
        user_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignedRoleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_role_api_v1_users__user_id__roles_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the user. You can obtain it from the Get Users endpoint. */
        user_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignedRoleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_role_api_v1_users__user_id__unassign_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description A unique identifier of the user. You can obtain it from the Get Users endpoint. */
        user_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkspaceName'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workspaces_api_v1_workspaces_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkspaceList'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_workspace_api_v1_workspaces_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NewWorkspace'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description The name of the workspace '{workspace_name}' must contain more than 3 characters. Give your workspace a longer name. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Creating workspaces is not supported with your current plan. Please contact deepset support. */
      402: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the specified credentials. Use the endpoint 'list_available_opensearch_credentials' for listing document store credentials in your organization and 'list_available_s3_credentials' for listing S3 credentials in your organization. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description You reached the workspace limit. Delete an existing workspace to create a new one. */
      406: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description This workspace {workspace_name} already exists. Try giving your new workspace a different name. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workspace_api_v1_workspaces__workspace_name__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Workspace'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_workspace_api_v1_workspaces__workspace_name__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_datasets_api_v1_workspaces__workspace_name__datasets_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DatasetPagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_files_api_v1_workspaces__workspace_name__datasets__dataset_name__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        dataset_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Dataset uploaded successfully */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Dataset not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_files_api_v1_workspaces__workspace_name__files_get: {
    parameters: {
      query?: {
        /** @description The name of the file you want to view. */
        name?: string | null;
        /** @description The contents of the file you want to view. */
        content?: string | null;
        /**
         * @deprecated
         * @description Type the metadata key by which you want to filter the files.
         */
        meta_key?: string | null;
        /**
         * @deprecated
         * @description Type the metadata value by which you want to filter the files.
         */
        meta_value?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter a value if you want to see all files that are sorted after this value and a file ID defined in the 'after_file_id' parameter. This value must match the type of the field you want to sort by. You can only use this parameter in combination with the 'after_file_id' parameter. If you are using the default sorting by 'created_at', you can set this value to an URL-encoded datetime in the ISO format. For example: Use '2023-04-25T07%3A37%3A58.326042%2B00%3A00' to filter for files created after '2023-04-25T07:37:58.326042+00:00'. */
        after_value?: unknown | null;
        /** @description Enter a file ID if you want to see all files after this file ID.You can only use this parameter in combination with the 'after_value' parameter. */
        after_file_id?: string | null;
        /** @description The name of the entity you want to sort by. */
        field?: PathsApiV1WorkspacesWorkspace_nameFilesGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1WorkspacesWorkspace_nameFilesGetParametersQueryOrder;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FilePagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_file_api_v1_workspaces__workspace_name__files_post: {
    parameters: {
      query?: {
        /** @description The name of the file you want to create. Use this field only if you're creating a file to upload. If you're uploading an existing file, leave this field empty. */
        file_name?: string | null;
        /** @description The write mode determines how to handle uploading a file if it's already in the workspace. Your options are: KEEP: keep the file with the same name, FAIL: make the request fail if a file with the same name already exists, or OVERWRITE: overwrite the file. If you choose to overwrite, all files with the same name are overwritten. */
        write_mode?: components['schemas']['FileWriteModeEnum'];
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_file_api_v1_workspaces__workspace_name__files_post'];
      };
    };
    responses: {
      /** @description Your file's in the workspace. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadFileResponse'];
        };
      };
      /** @description We couldn't upload your file because some of the arguments specified were incompatible. You can upload a file from your disk or create a file by providing a file name and text as its contents.  */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description You've either reached the file limit or the file size limit for your organization. Upgrade to a plan with more file limits. */
      402: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description A file with the name '<your file name>' already exists in the workspace. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Too large payload.Either the file uploaded is larger than 200 MB or the metadata you tried to upload is too large. The string '<your-string>' of key '<your-key>' is longer than 32766 bytes, which approximately equals the same number of characters.To upload files larger than 200 MB, use the [deepset SDK](https://github.com/deepset-ai/deepset-cloud-sdk). */
      413: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description deepset AI Platform supports .txt, .csv, .json, .xml, .html, .md, .pdf, .docx, .pptx, .xlsx, .xlsb, .xlsm, .msg and .zip files. Upload a file in the supported format. */
      415: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_files_api_v1_workspaces__workspace_name__files_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FileNames'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_files_api_v1_workspaces__workspace_name__files__search_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': {
          [key: string]: unknown;
        };
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_file_meta_bulk_api_v1_workspaces__workspace_name__files_update_meta_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateFileMetaBulkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateFileMetaBulkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_file_api_v1_workspaces__workspace_name__files__file_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        file_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description There's no file with the ID '<file_id>' in the workspace. Check if the ID is correct. You can use the `list_files` endpoint to check file IDs. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description File with the ID '{file_id}' doesn't have a type. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  delete_file_api_v1_workspaces__workspace_name__files__file_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        file_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_file_meta_api_v1_workspaces__workspace_name__files__file_id__meta_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        file_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FileMetadata'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_file_meta_api_v1_workspaces__workspace_name__files__file_id__meta_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        file_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FileMetadata'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_indexes_api_v1_workspaces__workspace_name__indexes_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the entity you want to sort by. */
        field?: PathsApiV1WorkspacesWorkspace_nameIndexesGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1WorkspacesWorkspace_nameIndexesGetParametersQueryOrder;
        /** @description Partial implementation of the OData $select operator. It currently only supports selecting fields from the root entity or a child entity. Selecting fields from children's children is not supported. If you use this parameter, the API answer is always a flat list of distinct JSON objects with the selected properties, for example, '[{"given_name": "user1", "user_id": "..."}, ...]' for 'select=created_by/given_name, created_by/user_id'. The results are ordered by the first selected attribute. To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        select?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineIndexPagination'];
        };
      };
      /** @description Workspace not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid filter expression */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  create_index_api_v1_workspaces__workspace_name__indexes_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreatePipelineIndexRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineIndex'];
        };
      };
      /** @description You've reached the maximum number of indexes for your organization. Delete an existing index to create a new one. */
      402: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description An index with this name already exists in your workspace. Choose a unique name for your index. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid request body or invalid index configuration. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_index_by_name_api_v1_workspaces__workspace_name__indexes__index_name__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
        /** @description The name of the pipeline index used to process the documents. */
        index_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineIndex'];
        };
      };
      /** @description Index or workspace not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_index_api_v1_workspaces__workspace_name__indexes__index_name__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
        /** @description Name of the pipeline index. */
        index_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline index is linked to a pipeline and cannot be deleted. Unlink the index from pipelines first. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_index_api_v1_workspaces__workspace_name__indexes__index_name__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
        /** @description Name of the pipeline index. */
        index_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePipelineIndexRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineIndex'];
        };
      };
      /** @description Index or workspace not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Cannot update 'name' or 'config_yaml' of a deployed pipeline index, or the index name already exists. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid request body or invalid index configuration. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  deploy_index_api_v1_workspaces__workspace_name__indexes__index_name__deploy_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
        /** @description Name of the pipeline index. */
        index_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineIndex'];
        };
      };
      /** @description Enabling the pipeline index failed because the pipeline index is not valid. Check the index configuration or choose a valid index. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description The model referenced in the pipeline index was not found, so the index was not created. Ensure the model exists.  */
      424: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  count_documents_api_v1_workspaces__workspace_name__indexes__index_name__documents_count_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline. */
        index_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Documents retrieved successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DCDocumentCount'];
        };
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  count_documents_deprecated_api_v1_workspaces__workspace_name__indexes__index_name__documents_count_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
        /** @description The name of the pipeline. */
        index_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CountDocumentsParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DCDocumentCount'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  query_documents_api_v1_workspaces__workspace_name__indexes__index_name__documents_query_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline. */
        index_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['QueryDocumentsParams'];
      };
    };
    responses: {
      /** @description Documents retrieved successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RawHaystackDocument'][];
        };
      };
      /** @description Invalid query parameters. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_all_documents_stream_api_v1_workspaces__workspace_name__indexes__index_name__documents_stream_post: {
    parameters: {
      query?: never;
      header?: {
        accept?: string;
      };
      path: {
        /** @description The name of the pipeline. */
        index_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FetchDocumentsParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The server cannot produce a response matching the request. Requested format: your-accept-header */
      406: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_document_api_v1_workspaces__workspace_name__indexes__index_name__documents__document_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The identifier of the document. To obtain the ID, you can call the Get All Documents endpoint. */
        document_id: string;
        /** @description The name of the pipeline. */
        index_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Documents retrieved successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RawHaystackDocument'];
        };
      };
      /** @description Document '{document_id}' doesn't exist in index '{index_name}'.  */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_indexed_files_by_status_api_v1_workspaces__workspace_name__indexes__index_name__files_get: {
    parameters: {
      query?: {
        /** @description The indexing status of the files you want to display. */
        status?: components['schemas']['FileStatus'];
      };
      header?: never;
      path: {
        /** @description Name of the pipeline index. */
        index_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string[];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  schedule_single_file_for_indexing_api_v1_workspaces__workspace_name__indexes__index_name__files__file_id__reindex_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Name of the pipeline index. */
        index_name: string;
        /** @description Unique identifier of a file. */
        file_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline index is not enabled. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_index_logs_api_v1_workspaces__workspace_name__indexes__index_name__logs_get: {
    parameters: {
      query?: {
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
        limit?: number;
        after?: string | null;
        order?: components['schemas']['SortingOrderEnum'];
      };
      header?: {
        /** @description The format of the index logs. Supported formats: text/csv, application/json */
        accept?: string | null;
      };
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
        /** @description The name of the pipeline index used to process the documents. */
        index_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The index logs were successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['PipelineLogPagination']
            | string
            | components['schemas']['PipelineLogPagination'];
        };
      };
      /** @description The pipeline index logs could not be retrieved. Check the filters and try again. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The logs weren't found for the index <your-index-name>. Check if the index name is correct and if the index exists. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description The pipeline index logs could not be retrieved within the timeout period. Try again in a couple of minutes. */
      504: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  undeploy_index_api_v1_workspaces__workspace_name__indexes__index_name__undeploy_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
        /** @description Name of the pipeline index. */
        index_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineIndex'];
        };
      };
      /** @description The pipeline index is referenced by deployed pipelines and cannot be disabled. Undeploy the connected pipelines first. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_visualization_api_v1_workspaces__workspace_name__indexes__index_name__visualization_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline index used to process the documents. */
        index_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The visualization metadata of the pipeline index. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineVisualizationMetadata-Output'];
        };
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_pipeline_visualization_api_v1_workspaces__workspace_name__indexes__index_name__visualization_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline index used to process the documents. */
        index_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PipelineVisualizationMetadata-Input'];
      };
    };
    responses: {
      /** @description The updated visualization metadata of the pipeline index. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineVisualizationMetadata-Output'];
        };
      };
      /** @description The index was not found in the workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_pipeline_templates_api_v1_workspaces__workspace_name__pipeline_templates_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the entity you want to sort by. */
        field?: PathsApiV1WorkspacesWorkspace_namePipeline_templatesGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1WorkspacesWorkspace_namePipeline_templatesGetParametersQueryOrder;
        /** @description Partial implementation of the OData $select operator. It currently only supports selecting fields from the root entity or a child entity. Selecting fields from children's children is not supported. If you use this parameter, the API answer is always a flat list of distinct JSON objects with the selected properties, for example, '[{"given_name": "user1", "user_id": "..."}, ...]' for 'select=created_by/given_name, created_by/user_id'. The results are ordered by the first selected attribute. To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        select?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedPipelineTemplates'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_template_api_v1_workspaces__workspace_name__pipeline_templates__pipeline_name__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Return pipeline template by 'pipeline_name'. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineTemplate'];
        };
      };
      /** @description The pipeline template you specified doesn't exist. Check if the 'pipeline_name' is correct. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  validate_pipeline_api_v1_workspaces__workspace_name__pipeline_validations_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ValidatePipelineYaml'];
      };
    };
    responses: {
      /** @description Your pipeline is valid. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Check the pipeline configuration and make sure the components and parameters are correct. Additionally, make sure third-party models are accessible. You can connect deepset AI Platform to model providers using Connections or by passing the provider's API key. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description A pipeline with this name is already in your workspace. You can't create pipelines with the same names. Give your pipeline a unique name and save it. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The uploaded pipeline is not a valid YAML.
       *     Details: {error} */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the model used in this pipeline so the pipeline wasn't created. Make sure you use an existing model. */
      424: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_pipelines_api_v1_workspaces__workspace_name__pipelines_get: {
    parameters: {
      query?: {
        /** @description The name of the pipeline you want to list. */
        pipeline_name?: string | null;
        /** @description Returns deleted pipelines. */
        deleted?: boolean;
        /** @description The status of the pipelines you want to list. */
        status?: PathsApiV1WorkspacesWorkspace_namePipelinesGetParametersQueryStatus | null;
        /** @description The desired status of the pipelines you want to list. */
        desired_status?: PathsApiV1WorkspacesWorkspace_namePipelinesGetParametersQueryDesired_status | null;
        /** @description The service level of the pipelines you want to list. */
        service_level?: components['schemas']['PipelineServiceLevelWithDraftEnum'] | null;
        /** @description Returns pipelines that support prompts. */
        supports_prompt?: boolean | null;
        /** @description The ID of the index you want to use for filtering. */
        pipeline_index_id?: string | null;
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the field you want to sort by. */
        field?: PathsApiV1WorkspacesWorkspace_namePipelinesGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1WorkspacesWorkspace_namePipelinesGetParametersQueryOrder;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelinePagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_pipeline_api_v1_workspaces__workspace_name__pipelines_post: {
    parameters: {
      query?: {
        /** @description Validates the pipeline without actually storing it. */
        dry_run?: boolean | null;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreatePipeline'];
      };
    };
    responses: {
      /** @description Your pipeline was created. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineName'];
        };
      };
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineName'];
        };
      };
      /** @description You've reached the maximum number of pipelines for your organization. */
      402: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description A pipeline with this name is already in your workspace. You can't create pipelines with the same names. Give your pipeline a unique name and save it. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid request body or pipeline configuration. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the model used in this pipeline so the pipeline wasn't created. Make sure you use an existing model. */
      424: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to fetch. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Pipeline'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to delete. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The pipeline was successfully deleted. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description The pipeline wasn't found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PipelineUpdateRequest'];
      };
    };
    responses: {
      /** @description The pipeline was successfully renamed. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline name is invalid. Make sure the name only contains valid characters. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description You don't have permission to update this pipeline. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the pipeline you specified. Make sure the name is correct and the pipeline exists in the workspace you specified. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Pipeline with the same name already exists, you're trying to activate an undeployed pipeline or you're trying to change the pipeline service level of an undeployed pipeline. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description We could not activate the pipeline because the linked index was not found. Please check if the index exists and is linked to the pipeline. */
      424: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  activate_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__activate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The pipeline was successfully activated. This may take a couple of minutes to take effect. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description You don't have permission to update this pipeline. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the pipeline you specified. Make sure the name is correct and the pipeline exists in the workspace you specified. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Pipeline with the same name already exists, you're trying to activate an undeployed pipeline or you're trying to change the pipeline service level of an undeployed pipeline. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description We could not activate the pipeline because the linked index was not found. Please check if the index exists and is linked to the pipeline. */
      424: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  chat_api_v1_workspaces__workspace_name__pipelines__pipeline_name__chat_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to use for search. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ChatQuery'];
      };
    };
    responses: {
      /** @description Returns the search results. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResult'];
        };
      };
      /** @description We couldn't find the pipeline. Check if the pipeline name is correct, make sure the pipeline exists in the workspace you specified, and try again. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The request sent to your pipeline timed out. */
      408: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was in a conflicted state (for example, it wasn't deployed). */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description The pipeline is temporarily unavailable because of internal rebalancing processes. Try again in a few moments. */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was on standby, and is now being activated. Try again in a while. */
      591: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  chat_stream_api_v1_workspaces__workspace_name__pipelines__pipeline_name__chat_stream_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to use for search. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ChatStreamingQuery'];
      };
    };
    responses: {
      /** @description Returns the search results. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
          'text/event-stream': unknown;
        };
      };
      /** @description We couldn't find the pipeline. Check if the pipeline name is correct, make sure the pipeline exists in the workspace you specified, and try again. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was in a conflicted state (for example, it wasn't deployed). */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description The pipeline was on standby, and is now being activated. Try again in a while. */
      591: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  set_default_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__default_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  deploy_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__deploy_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to deploy. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Pipeline'];
        };
      };
      /** @description The pipeline configuration is incorrect or the pipeline references disabled indexes. Ensure the pipeline configuration is valid and and all the connected indexes are enabled. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline with name '{pipeline_name}' could not be found. Try specifying a different pipeline. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_issues_api_v1_workspaces__workspace_name__pipelines__pipeline_name__issues_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Recent issues that occurred during running a pipeline. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineIssues'];
        };
      };
      /** @description The pipeline doesn't exist in the workspace or pipeline logs could not be found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Fetching logs from OpenSearch timed out. Try again later. */
      504: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_pipeline_logs_api_v1_workspaces__workspace_name__pipelines__pipeline_name__logs_get: {
    parameters: {
      query?: {
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
        limit?: number;
        after?: string | null;
        order?: components['schemas']['SortingOrderEnum'];
      };
      header?: {
        /** @description Type 'text/csv' to download the logs as a CSV file or 'application/json' to get the logs as JSONs. */
        accept?: string | null;
      };
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
        /** @description Name of the pipeline. */
        pipeline_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description List log messages for the given pipeline. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['PipelineLogPagination']
            | string
            | components['schemas']['PipelineLogPagination'];
        };
      };
      /** @description The filters you provided are invalid. Check the filters and try again. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The given pipeline does not exist or does not have logs. [List the deployed pipelines](https://docs.cloud.deepset.ai/reference/list_pipelines_api_v1_workspaces__workspace_name__pipelines_get) to get a list of valid pipeline names. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Fetching logs timed out. Try again later. */
      504: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_pipeline_index_metadata_api_v1_workspaces__workspace_name__pipelines__pipeline_name__meta_get: {
    parameters: {
      query?: {
        /** @description Whether to return information about nested metadata fields. */
        return_nested?: boolean;
      };
      header?: never;
      path: {
        /** @description The name of the pipeline whose files you want to display. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Metadata for the pipeline's index. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: components['schemas']['PipelineIndexMetadataProperty'];
          };
        };
      };
      /** @description The pipeline you specified doesn't exist in this workspace. Check if the pipeline name is correct. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description This pipeline's index doesn't exist or isn't enabled. Ensure the index connected to this pipeline exists and is enabled. */
      412: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_metadata_field_values_api_v1_workspaces__workspace_name__pipelines__pipeline_name__meta__field_name__get: {
    parameters: {
      query?: {
        /** @description The query you want to use to search through metadata. You can use wildcards in the query, for example, '*query*' to list all values which contain the term 'query'. */
        query?: string | null;
        /** @description How many entries do you want to display? */
        limit?: number;
        /** @description Enter the offset for the pagination. Note that the results are 0-indexed which means that with 'after=0', you will skip the first element. */
        after?: number;
      };
      header?: never;
      path: {
        /** @description The name of the pipeline whose metadata field values you want to display. */
        pipeline_name: string;
        /** @description The name of the metadata field to search in. Use dot notation to search nested fields. */
        field_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Metadata for the pipeline's index. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineFieldSearchResult'];
        };
      };
      /** @description We couldn't find the metadata field possibly because it doesn't support text search.Use the 'GET '/workspaces/{workspace_name}/pipelines/{pipeline_name}/meta' endpoint to to check if this field supports text search. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline you specified doesn't exist in this workspace. Check if the pipeline name is correct. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description This pipeline's index doesn't exist or isn't enabled. Ensure the index connected to this pipeline exists and is enabled. */
      412: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_min_max_aggregation_metadata_api_v1_workspaces__workspace_name__pipelines__pipeline_name__meta__meta_field__aggregation_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline whose files you want to display. */
        pipeline_name: string;
        /** @description The name of the metadata field to get the min and max values for. */
        meta_field: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Min and max value aggregation of the meta_field */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineMetadataAggregation'];
        };
      };
      /** @description The metadata field '{meta_field}' doesn't exist or doesn't support aggregation. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline you specified doesn't exist in this workspace. Check if the pipeline name is correct. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description This pipeline hasn't been deployed and indexed yet. Deploy this pipeline to fetch the metadata. */
      412: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_prompt_api_v1_workspaces__workspace_name__pipelines__pipeline_name__prompt_get: {
    parameters: {
      query?: {
        /** @description Convert Haystack special tokens like `{new_line}` in prompt. */
        convert_special_tokens?: boolean;
      };
      header?: never;
      path: {
        /** @description The name of the pipeline you want to fetch. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelinePrompt'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_prompts_api_v1_workspaces__workspace_name__pipelines__pipeline_name__prompts_get: {
    parameters: {
      query?: {
        /** @description Convert Haystack special tokens like `{new_line}` in prompt. */
        convert_special_tokens?: boolean;
      };
      header?: never;
      path: {
        /** @description The name of the pipeline you want to fetch. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelinePrompts'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to use for search. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PipelineQuery'];
      };
    };
    responses: {
      /** @description Returns the search results. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResult'];
        };
      };
      /** @description Invalid search response format received from the pipeline. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the pipeline. Check if the pipeline name is correct, make sure the pipeline exists in the workspace you specified, and try again. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The request sent to your pipeline timed out. */
      408: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was in a conflicted state (for example, it wasn't deployed). */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description An internal error occurred while querying the pipeline. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline is temporarily unavailable because of internal rebalancing processes. Try again in a few moments. */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was on standby, and is now being activated. Try again in a while. */
      591: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  search_stream_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_stream_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to use for search. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StreamingQuery'];
      };
    };
    responses: {
      /** @description Returns the search results. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
          'text/event-stream': unknown;
        };
      };
      /** @description We couldn't find the pipeline. Check if the pipeline name is correct, make sure the pipeline exists in the workspace you specified, and try again. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was in a conflicted state (for example, it wasn't deployed). */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description The pipeline was on standby, and is now being activated. Try again in a while. */
      591: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  pipeline_search_history_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_history_get: {
    parameters: {
      query?: {
        /** @description If set to true, only returns search history from the recent cache (2 days), which speeds up the API call. */
        recent?: boolean;
        /** @description How many entries do you want to display? */
        limit?: number;
        /** @description Enter the offset for the pagination. Note that the results are 0-indexed which means that with 'after=0', you will skip the first element. */
        after?: number;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchHistoryPagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  pipeline_search_history_archive_api_v1_workspaces__workspace_name__pipelines__pipeline_name__search_history_archive_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter the URL-encoded datetime in ISO format if you want to see all entries preceding this datetime. */
        after?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchHistoryPagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_stats_api_v1_workspaces__workspace_name__pipelines__pipeline_name__stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to fetch. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineStatistics'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  undeploy_pipeline_api_v1_workspaces__workspace_name__pipelines__pipeline_name__undeploy_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The name of the pipeline you want to undeploy. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Pipeline'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_visualization_api_v1_workspaces__workspace_name__pipelines__pipeline_name__visualization_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The visualization metadata of the pipeline. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineVisualizationMetadata-Output'];
        };
      };
      /** @description The specified pipeline could not be found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_pipeline_visualization_api_v1_workspaces__workspace_name__pipelines__pipeline_name__visualization_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PipelineVisualizationMetadata-Input'];
      };
    };
    responses: {
      /** @description The updated visualization metadata of the pipeline. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineVisualizationMetadata-Output'];
        };
      };
      /** @description The specified pipeline could not be found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_yaml_configs_api_v1_workspaces__workspace_name__pipelines__pipeline_name__yaml_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Specifies the name of the pipeline whose YAML you want to display. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Returns the pipeline as YAML. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineYAMLConfiguration'];
        };
      };
      /** @description A pipeline with this name wasn't found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_pipeline_yaml_api_v1_workspaces__workspace_name__pipelines__pipeline_name__yaml_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Name of the pipeline. */
        pipeline_name: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePipelineYAMLRequest'];
      };
    };
    responses: {
      /** @description The pipeline was successfully updated. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PipelineName'];
        };
      };
      /** @description The pipeline was not updated because the pipeline configurations isn't valid. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description You don't have permission to update this pipeline. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description We couldn't find the pipeline you specified. Make sure the name is correct and the pipeline exists in the workspace you specified. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was not updated because you can't update a deployed indexing pipeline. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was not updated because the pipeline yaml can't be processed. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The pipeline was not updated because the request data is invalid. */
      424: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_prompt_templates_api_v1_workspaces__workspace_name__prompt_templates_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the entity you want to sort by. */
        field?: PathsApiV1WorkspacesWorkspace_namePrompt_templatesGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1WorkspacesWorkspace_namePrompt_templatesGetParametersQueryOrder;
        /** @description Partial implementation of the OData $select operator. It currently only supports selecting fields from the root entity or a child entity. Selecting fields from children's children is not supported. If you use this parameter, the API answer is always a flat list of distinct JSON objects with the selected properties, for example, '[{"given_name": "user1", "user_id": "..."}, ...]' for 'select=created_by/given_name, created_by/user_id'. The results are ordered by the first selected attribute. To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        select?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedPromptTemplates'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_prompt_template_api_v1_workspaces__workspace_name__prompt_templates_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PromptTemplatePost'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_prompt_template_api_v1_workspaces__workspace_name__prompt_templates__prompt_template_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Unique identifier of the prompt template. */
        prompt_template_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PromptTemplatePut'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_prompt_templates_api_v1_workspaces__workspace_name__prompt_templates__prompt_template_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Unique identifier of the prompt template. */
        prompt_template_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_count_api_v1_workspaces__workspace_name__search_count_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchCountPagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_history_api_v1_workspaces__workspace_name__search_history_get: {
    parameters: {
      query?: {
        /** @description How many entries do you want to display? */
        limit?: number;
        /** @description Enter the offset for the pagination. Note that the results are 0-indexed which means that with 'after=0', you will skip the first element. */
        after?: number;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchHistoryPagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_search_sessions_api_v1_workspaces__workspace_name__search_sessions_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedSearchSessions'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_search_session_api_v1_workspaces__workspace_name__search_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SearchSessionPostBody'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchSessionPostResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_search_session_api_v1_workspaces__workspace_name__search_sessions__search_session_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the search session you want to delete. */
        search_session_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description We are processing your request to delete search session data. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Returned if search session id to be deleted is not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_prototypes_api_v1_workspaces__workspace_name__shared_prototypes_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedSharedPrototypes'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_prototype_api_v1_workspaces__workspace_name__shared_prototypes_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PostSharedPrototype'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharedPrototype'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_shared_prototype_api_v1_workspaces__workspace_name__shared_prototypes__shared_prototype_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the shared prototype */
        shared_prototype_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The requested prototype. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharedPrototype'];
        };
      };
      /** @description We couldn't find a shared prototype with the given ID. Make sure the ID is correct and try again. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revoke_shared_prototype_api_v1_workspaces__workspace_name__shared_prototypes__shared_prototype_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the shared prototype */
        shared_prototype_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The access to the prototype was revoked successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description We couldn't find a shared prototype with the given ID. Make sure the ID is correct and try again. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  edit_shared_prototype_api_v1_workspaces__workspace_name__shared_prototypes__shared_prototype_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the shared prototype */
        shared_prototype_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchSharedPrototype'];
      };
    };
    responses: {
      /** @description The prototype was successfully updated with the new values. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharedPrototype'];
        };
      };
      /** @description We couldn't find a shared prototype with the given ID. Make sure the ID is correct and try again. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workspace_stats_api_v1_workspaces__workspace_name__stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkspaceStats'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_temporary_file_api_v1_workspaces__workspace_name__temporary_files_post: {
    parameters: {
      query?: {
        /** @description The name of the file you want to create. Use this field only if you're creating a file to upload. If you're uploading an existing file, leave this field empty. */
        file_name?: string | null;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_temporary_file_api_v1_workspaces__workspace_name__temporary_files_post'];
      };
    };
    responses: {
      /** @description Your file's in the workspace. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadFileResponse'];
        };
      };
      /** @description We couldn't upload your file because some of the arguments specified were incompatible. You can upload a file from your disk or create a file by providing a file name and text as its contents.  */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Too large payload.Either the file uploaded is larger than 200 MB or the metadata you tried to upload is too large. The string '<your-string>' of key '<your-key>' is longer than 32766 bytes, which approximately equals the same number of characters.To upload files larger than 200 MB, use the [deepset SDK](https://github.com/deepset-ai/deepset-cloud-sdk). */
      413: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description deepset AI Platform supports .txt, .csv, .json, .xml, .html, .md, .pdf, .docx, .pptx, .xlsx, .xlsb, .xlsm, .msg and .zip files. Upload a file in the supported format. */
      415: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_temporary_file_api_v1_workspaces__workspace_name__temporary_files__file_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        file_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description There's no file with the ID '<file_id>' in the workspace. Check if the ID is correct. You can use the `list_files` endpoint to check file IDs. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description File with the ID '{file_id}' doesn't have a type. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_upload_sessions_api_v1_workspaces__workspace_name__upload_sessions_get: {
    parameters: {
      query?: {
        /** @description Specifies if the session is expired. */
        is_expired?: boolean | null;
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the field you want to sort by. */
        field?: PathsApiV1WorkspacesWorkspace_nameUpload_sessionsGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1WorkspacesWorkspace_nameUpload_sessionsGetParametersQueryOrder;
      };
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Your upload sessions. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedSession'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_upload_session_api_v1_workspaces__workspace_name__upload_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSession'];
      };
    };
    responses: {
      /** @description Your session is created. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadSession'];
        };
      };
      /** @description You can't upload to this workspace through upload sessions on a free plan. To use this feature, upgrade to a paid plan. You can still upload files through the UI at no cost. */
      402: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description You can't upload files because you've reached the maximum number of upload sessions allowed per user. Close existing sessions using the Close Session endpoint before starting a new one. */
      406: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_status_api_v1_workspaces__workspace_name__upload_sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the session. */
        session_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Your upload sessions. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionDetail'];
        };
      };
      /** @description There's no session with the ID '{session_id}' in the workspace. Check if the ID is correct.  */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  close_session_api_v1_workspaces__workspace_name__upload_sessions__session_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the session. */
        session_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CloseSession'];
      };
    };
    responses: {
      /** @description Your session details. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description There's no session with the ID '{session_id}' in the workspace. Check if the ID is correct.  */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The session is already closed. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_files_api_v1_workspaces__workspace_name__upload_sessions__session_id__files_get: {
    parameters: {
      query?: {
        /** @description Use this option to filter for files that are still being ingested or that were already ingested. */
        ingestion_status?: components['schemas']['FileIngestionStatusEnum'] | null;
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the field you want to sort by. */
        field?: PathsApiV1WorkspacesWorkspace_nameUpload_sessionsSession_idFilesGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV1WorkspacesWorkspace_nameUpload_sessionsSession_idFilesGetParametersQueryOrder;
      };
      header?: never;
      path: {
        /** @description The ID of the session. */
        session_id: string;
        /** @description Type the name of the workspace. */
        workspace_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Returns a list of files registered to the session. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedSessionFile'];
        };
      };
      /** @description There's no session with the ID '{session_id}' in the workspace. Check if the ID is correct.  */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_custom_components_api_v2_custom_components_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the entity you want to sort by. */
        field?: PathsApiV2Custom_componentsGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV2Custom_componentsGetParametersQueryOrder;
        /** @description Partial implementation of the OData $select operator. It currently only supports selecting fields from the root entity or a child entity. Selecting fields from children's children is not supported. If you use this parameter, the API answer is always a flat list of distinct JSON objects with the selected properties, for example, '[{"given_name": "user1", "user_id": "..."}, ...]' for 'select=created_by/given_name, created_by/user_id'. The results are ordered by the first selected attribute. To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        select?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedCustomComponents'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_custom_components_api_v2_custom_components_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_import_custom_components_api_v2_custom_components_post'];
      };
    };
    responses: {
      /** @description Returns the ID of the imported custom component. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CustomComponent'];
        };
      };
      /** @description Something went wrong while validating the custom component. {error_message} */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Change the version of this custom component and upload it again. A custom component with this version already exists in your workspace. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Upload a valid ZIP file as the custom component. Currently, we only support the ZIP format for custom components. */
      415: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_custom_component_logs_api_v2_custom_components_logs_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Returns the installation logs for the custom component as a text. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
        };
      };
      /** @description You are not authorized to download the logs of these custom components. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description You don't have permissions to download the logs of these custom components. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Raised when the custom component logs are not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The requested resources are inactive due to user inactivity. Log in to deepset Cloud to re-enable access. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description An internal server error occured while retrieving the custom component logs. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_custom_component_api_v2_custom_components__custom_component_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        custom_component_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CustomComponent'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_secrets_api_v2_secrets_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the field you want to sort by. */
        field?: PathsApiV2SecretsGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV2SecretsGetParametersQueryOrder;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SecretPagination'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_secret_api_v2_secrets_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSecret'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_secret_api_v2_secrets__secret_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Unique identifier of the secret. */
        secret_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Secret'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_secret_api_v2_secrets__secret_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Unique identifier of the secret. */
        secret_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_debug_tunnel_api_v2_workspaces__workspace_id__pipelines__pipeline_id__debug_tunnel_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Unique identifier of the pipeline you want to debug. */
        pipeline_id: string;
        /** @description Type the id of the workspace. */
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Debug tunnel started. */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DebugTunnelDeviceLoginCredentials'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Debug tunnel device login failed. */
      424: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_paginated_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the entity you want to sort by. */
        field?: PathsApiV2WorkspacesWorkspace_idPipelinesPipeline_idFeedbackGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV2WorkspacesWorkspace_idPipelinesPipeline_idFeedbackGetParametersQueryOrder;
        /** @description Partial implementation of the OData $select operator. It currently only supports selecting fields from the root entity or a child entity. Selecting fields from children's children is not supported. If you use this parameter, the API answer is always a flat list of distinct JSON objects with the selected properties, for example, '[{"given_name": "user1", "user_id": "..."}, ...]' for 'select=created_by/given_name, created_by/user_id'. The results are ordered by the first selected attribute. To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        select?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedFeedback'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateFeedback'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Feedback'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback_export_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pipeline_feedback_stats_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback_stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FeedbackStats'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback__feedback_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
        feedback_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_feedback_api_v2_workspaces__workspace_id__pipelines__pipeline_id__feedback__feedback_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
        feedback_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateFeedback'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Feedback'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_pipeline_search_history_api_v2_workspaces__workspace_id__pipelines__pipeline_id__search_history_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Unique identifier of a pipeline. */
        pipeline_id: string;
        /** @description Type the id of the workspace. */
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  pipeline_search_history_result_api_v2_workspaces__workspace_id__pipelines__pipeline_id__search_history__query_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Unique identifier of a pipeline. */
        pipeline_id: string;
        /** @description Unique identifier of the search query. */
        query_id: string;
        /** @description Type the id of the workspace. */
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchHistoryV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_paginated_tags_api_v2_workspaces__workspace_id__pipelines__pipeline_id__tags_get: {
    parameters: {
      query?: {
        /** @description The number of entries to display. Leaving this field empty keeps the default, and max 10 results are returned. */
        limit?: number;
        /** @description Enter an ID if you want to see all entries before this ID. To use this option, clear the `page_number` parameter first. */
        before?: string | null;
        /** @description Enter an ID if you want to see all entries after this ID. To use this option, clear the `page_number` parameter first. */
        after?: string | null;
        /** @description The number of the page you want to see. */
        page_number?: number | null;
        /** @description The name of the entity you want to sort by. */
        field?: PathsApiV2WorkspacesWorkspace_idPipelinesPipeline_idTagsGetParametersQueryField;
        /** @description Choose how you want to sort the results. */
        order?: PathsApiV2WorkspacesWorkspace_idPipelinesPipeline_idTagsGetParametersQueryOrder;
        /** @description Partial implementation of the OData $select operator. It currently only supports selecting fields from the root entity or a child entity. Selecting fields from children's children is not supported. If you use this parameter, the API answer is always a flat list of distinct JSON objects with the selected properties, for example, '[{"given_name": "user1", "user_id": "..."}, ...]' for 'select=created_by/given_name, created_by/user_id'. The results are ordered by the first selected attribute. To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        select?: string | null;
        /** @description The OData filter you want to use to in your query. It supports exact match and `AND` operations. For example, to filter for a metadata `category:news` and `published_date` greater than or equal to January 1 2025, here's what the URL could look like: 'url = "https://api.cloud.deepset.ai/api/v1/workspaces/production/files?limit=10&filter=category eq 'news' and published_date ge '2025-01-01' "'. OData filters only work with cursor-based pagination (leave the `page_number` field blank to enable it).To learn more about the OData filter syntax, see: [Querying Data](https://www.odata.org/getting-started/basic-tutorial/#queryData). */
        filter?: string | null;
      };
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedTags'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_tags_api_v2_workspaces__workspace_id__pipelines__pipeline_id__tags_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTag'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FeedbackTag'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_tags_api_v2_workspaces__workspace_id__pipelines__pipeline_id__tags__tag_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Type the id of the workspace. */
        workspace_id: string;
        pipeline_id: string;
        tag_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  health_health_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string;
        };
      };
    };
  };
}
export enum PathsApiV1Public_prompt_templatesGetParametersQueryField {
  name = 'name',
  created_at = 'created_at',
}
export enum PathsApiV1Public_prompt_templatesGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV1TokenGetParametersQueryField {
  name = 'name',
  role = 'role',
  created_at = 'created_at',
  expires_at = 'expires_at',
}
export enum PathsApiV1TokenGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV1WorkspacesWorkspace_nameFilesGetParametersQueryField {
  created_at = 'created_at',
  name = 'name',
}
export enum PathsApiV1WorkspacesWorkspace_nameFilesGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV1WorkspacesWorkspace_nameIndexesGetParametersQueryField {
  name = 'name',
  created_at = 'created_at',
  created_by_user_id = 'created_by/user_id',
  created_by_given_name = 'created_by/given_name',
  created_by_family_name = 'created_by/family_name',
}
export enum PathsApiV1WorkspacesWorkspace_nameIndexesGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV1WorkspacesWorkspace_namePipeline_templatesGetParametersQueryField {
  name = 'name',
  created_at = 'created_at',
}
export enum PathsApiV1WorkspacesWorkspace_namePipeline_templatesGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV1WorkspacesWorkspace_namePipelinesGetParametersQueryStatus {
  UNDEPLOYED = 'UNDEPLOYED',
  DEPLOYED_UNHEALTHY = 'DEPLOYED_UNHEALTHY',
  DEPLOYED = 'DEPLOYED',
  DEPLOYMENT_IN_PROGRESS = 'DEPLOYMENT_IN_PROGRESS',
  UNDEPLOYMENT_IN_PROGRESS = 'UNDEPLOYMENT_IN_PROGRESS',
  DEPLOYMENT_SCHEDULED = 'DEPLOYMENT_SCHEDULED',
  UNDEPLOYMENT_SCHEDULED = 'UNDEPLOYMENT_SCHEDULED',
  UNDEPLOYMENT_FAILED = 'UNDEPLOYMENT_FAILED',
  DEPLOYMENT_FAILED = 'DEPLOYMENT_FAILED',
  IDLE = 'IDLE',
  ACTIVATING = 'ACTIVATING',
}
export enum PathsApiV1WorkspacesWorkspace_namePipelinesGetParametersQueryDesired_status {
  UNDEPLOYED = 'UNDEPLOYED',
  DEPLOYED = 'DEPLOYED',
}
export enum PathsApiV1WorkspacesWorkspace_namePipelinesGetParametersQueryField {
  created_at = 'created_at',
  name = 'name',
  service_level = 'service_level',
  created_by_user_id = 'created_by/user_id',
  created_by_given_name = 'created_by/given_name',
  created_by_family_name = 'created_by/family_name',
  service_level_created_at = 'service_level,created_at',
}
export enum PathsApiV1WorkspacesWorkspace_namePipelinesGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV1WorkspacesWorkspace_namePrompt_templatesGetParametersQueryField {
  name = 'name',
  created_at = 'created_at',
}
export enum PathsApiV1WorkspacesWorkspace_namePrompt_templatesGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV1WorkspacesWorkspace_nameUpload_sessionsGetParametersQueryField {
  created_at = 'created_at',
  expires_at = 'expires_at',
  ingestion_status_reason = 'ingestion_status_reason',
  name = 'name',
  file_count = 'file_count',
  status = 'status',
  write_mode = 'write_mode',
}
export enum PathsApiV1WorkspacesWorkspace_nameUpload_sessionsGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV1WorkspacesWorkspace_nameUpload_sessionsSession_idFilesGetParametersQueryField {
  created_at = 'created_at',
  ingestion_status = 'ingestion_status',
  ingestion_status_reason = 'ingestion_status_reason',
  name = 'name',
}
export enum PathsApiV1WorkspacesWorkspace_nameUpload_sessionsSession_idFilesGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV2Custom_componentsGetParametersQueryField {
  version = 'version',
  status = 'status',
  created_at = 'created_at',
}
export enum PathsApiV2Custom_componentsGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV2SecretsGetParametersQueryField {
  name = 'name',
  created_at = 'created_at',
}
export enum PathsApiV2SecretsGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV2WorkspacesWorkspace_idPipelinesPipeline_idFeedbackGetParametersQueryField {
  created_at = 'created_at',
  search_history_rank = 'search_history/rank',
  search_history_score = 'search_history/score',
  search_history_search_query = 'search_history/search_query',
}
export enum PathsApiV2WorkspacesWorkspace_idPipelinesPipeline_idFeedbackGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum PathsApiV2WorkspacesWorkspace_idPipelinesPipeline_idTagsGetParametersQueryField {
  name = 'name',
  created_at = 'created_at',
}
export enum PathsApiV2WorkspacesWorkspace_idPipelinesPipeline_idTagsGetParametersQueryOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum Action {
  read = 'read',
  write = 'write',
}
export enum Assets {
  files = 'files',
  indexes = 'indexes',
  shared_prototypes = 'shared_prototypes',
  pipelines = 'pipelines',
  pipeline_templates = 'pipeline_templates',
  '*' = '*',
}
export enum ComparisonOperator {
  '==' = '==',
  '!=' = '!=',
  '>' = '>',
  '>=' = '>=',
  '<' = '<',
  '<=' = '<=',
  in = 'in',
  not_in = 'not in',
}
export enum ComponentDomain {
  deepset_cloud = 'deepset-cloud',
  community = 'community',
}
export enum DeepsetCloudAnswerType {
  generative = 'generative',
  extractive = 'extractive',
  other = 'other',
}
export enum DeepsetCloudVersion {
  v2 = 'v2',
}
export enum FileIngestionStatusEnum {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
}
export enum FileIngestionStatusReasonEnum {
  EMPTY_FILE = 'EMPTY_FILE',
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  FAILED_TO_PARSE_META = 'FAILED_TO_PARSE_META',
  FILE_ALREADY_EXISTS = 'FILE_ALREADY_EXISTS',
  INGESTING_FILE_FAILED = 'INGESTING_FILE_FAILED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  FILE_NAME_TOO_LONG_MAX_LENGTH_IS_800 = 'FILE NAME TOO LONG. MAX LENGTH IS 800',
  SLOWDOWN = 'SLOWDOWN',
}
export enum FileStatus {
  FAILED = 'FAILED',
  NO_DOCUMENTS = 'NO_DOCUMENTS',
}
export enum FileWriteModeEnum {
  KEEP = 'KEEP',
  OVERWRITE = 'OVERWRITE',
  FAIL = 'FAIL',
  TEMPORARY = 'TEMPORARY',
}
export enum LogOrigin {
  querypipeline = 'querypipeline',
  indexingpipeline = 'indexingpipeline',
  unknown = 'unknown',
}
export enum LogicalOperator {
  AND = 'AND',
  OR = 'OR',
  NOT = 'NOT',
}
export enum ModelProvider {
  aws_bedrock = 'aws-bedrock',
  azure_document_intelligence = 'azure-document-intelligence',
  azure_openai = 'azure-openai',
  cohere = 'cohere',
  deepl = 'deepl',
  google = 'google',
  huggingface = 'huggingface',
  nvidia = 'nvidia',
  openai = 'openai',
  searchapi = 'searchapi',
  snowflake = 'snowflake',
  unstructured = 'unstructured',
  voyage_ai = 'voyage-ai',
  wandb_ai = 'wandb-ai',
  mongodb = 'mongodb',
  together_ai = 'together-ai',
}
export enum OrganizationType {
  FULL_DEEPSET_CLOUD = 'FULL_DEEPSET_CLOUD',
  DEEPSET_STUDIO_WITH_LIMITS = 'DEEPSET_STUDIO_WITH_LIMITS',
}
export enum PipelineIndexDesiredStatus {
  DEPLOYED = 'DEPLOYED',
  UNDEPLOYED = 'UNDEPLOYED',
}
export enum PipelineServiceLevelEnum {
  DEVELOPMENT = 'DEVELOPMENT',
  PRODUCTION = 'PRODUCTION',
}
export enum PipelineServiceLevelWithDraftEnum {
  DRAFT = 'DRAFT',
  DEVELOPMENT = 'DEVELOPMENT',
  PRODUCTION = 'PRODUCTION',
}
export enum PipelineStatus {
  UNDEPLOYED = 'UNDEPLOYED',
  DEPLOYED_UNHEALTHY = 'DEPLOYED_UNHEALTHY',
  DEPLOYED = 'DEPLOYED',
  DEPLOYMENT_IN_PROGRESS = 'DEPLOYMENT_IN_PROGRESS',
  UNDEPLOYMENT_IN_PROGRESS = 'UNDEPLOYMENT_IN_PROGRESS',
  DEPLOYMENT_SCHEDULED = 'DEPLOYMENT_SCHEDULED',
  UNDEPLOYMENT_SCHEDULED = 'UNDEPLOYMENT_SCHEDULED',
  UNDEPLOYMENT_FAILED = 'UNDEPLOYMENT_FAILED',
  DEPLOYMENT_FAILED = 'DEPLOYMENT_FAILED',
  IDLE = 'IDLE',
  ACTIVATING = 'ACTIVATING',
}
export enum PipelineType {
  indexing = 'indexing',
  query = 'query',
}
export enum Roles {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  USER = 'USER',
  SEARCH_USER = 'SEARCH_USER',
  EXTERNAL = 'EXTERNAL',
  PIPELINE_STUDIO = 'PIPELINE_STUDIO',
  MAINTENANCE = 'MAINTENANCE',
}
export enum SessionStatusEnum {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  EXPIRED = 'EXPIRED',
}
export enum SortingOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum SupportRequestType {
  BUG = 'BUG',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  BILLING_QUESTION = 'BILLING_QUESTION',
  LEAVE_FEEDBACK = 'LEAVE_FEEDBACK',
  OTHER = 'OTHER',
}
export enum UserBlockedDescription {
  WORKAROUND = 'WORKAROUND',
  BLOCKED = 'BLOCKED',
  NOT_URGENT = 'NOT_URGENT',
  SEARCH_BROKEN = 'SEARCH_BROKEN',
}
